import React, { Component, Fragment } from 'react';
import TuneIcon from '@mui/icons-material/Tune';
import {
  Row,
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  Input,
  Card,
  CardTitle,
  CardBody,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  CardHeader,
  UncontrolledDropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Alert,
} from 'reactstrap';
import { connect } from 'react-redux';
import IntlMessages from '../../../../../helpers/IntlMessages';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import Visitor from '../../../../../containers/pages/visitor';
import DatePicker from 'react-datepicker';
import moment, { months } from 'moment';
import Select from 'react-select';
import country from '../../../../../data/country';
import topic from '../../../../../data/topic';
import { Client as ConversationsClient } from '@twilio/conversations';
import {
  gAPI_Conversations_list,
  postAPI_Create_Ticket,
  API_Web_RTC,
  gAPI_Users_By_Id,
  gAPI_TicketsRecording_id,
  gAPI_QuickReplies,
  gAPI_FormsCategoryList,
  gAPI_Conversations_By_Id,
  putAPI_UpdateAgentStatus_By_Id,
  putAPI_UpdateChatStatus_By_Id,
  API_Email_Integration,
  gAPI_QuickReplies_listByGroup,
  putAPI_ConversationsStatus_By_Id,
  postAPI_TrackEvent,
  putAPI_ConversationsTwilioStart,
  putAPI_ConversationsFacebookTransfer,
  gAPI_ConversationSummaryByAssistant,
  API_Whatsapp_Integration,
  gAPI_Internal_Property_By_Id,
  postAPI_CreateExportReport
} from '../../../../../constants/APIs';
import 'react-perfect-scrollbar/dist/css/styles.css';
import {
  AxiosAPI,
  getGroupID,
  getUserID,
  AxiosPublicAPI,
} from '../../../../../helpers/AxiosAPI';
import TwilioConversationApp from '../../conversations/components/TwilioConversationApp';
import {
  getChatList,
  getChatListSearch,
  getChat,
  getPropertyList,
  createTicket,
  BotBlink,
  AgentBlink,
  pushTwilioConversations,
} from '../../../../../redux/actions';
import {
  faSms,
  faFilter,
  faPlus,
  faPhone,
  faReply,
  faTicketAlt,
  faArrowDown,
  faLanguage,
} from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ChatMessage from '../../../../../components/chats/ChatMessage';
import { injectIntl } from 'react-intl';
import 'react-datepicker/dist/react-datepicker.css';
import {
  reactSelectOption,
  reactSelectOptionDiffrentPro,
} from '../../../../../helpers/Utils';
import Archives from '../../conversations/components/Archives';
import { localeOptions } from '../../../../../constants/defaultValues';
import 'moment-timezone';
import bot_icon from './../../../../../assets/bot_icon.png';
import Validation from '../../../../../components/Validation';
import classnames from 'classnames';
import WebRTC from '../Connections/WebRTC';
import ConnectOptions from './connectOptions';
import DialPad from './dialPad';
import KnowledgeSearch from './knowledgeSearch';
import ConversationSummary from './conversationSummary';
import phone_suite_calling_party from './../../../../../assets/phone_suite_calling_party.png';
import { AvailabilityAndRates } from './availability';
import Chat from '../../ongoingconversations/components/Chat';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import NewEmail from './EmailAssistant/NewEmail';
import NewWhatsAppConnection from './NewWhatsAppConnection';
import Reservations from './Reservations';
import { faFileExcel } from '@fortawesome/free-regular-svg-icons';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
const quillModules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }, { font: [] }],
    [{ size: [] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    ['link'],
    ['clean'],
  ],
};

const quillFormats = [
  'header',
  'size',
  'bold',
  'italic',
  'underline',
  'strike',
  'blockquote',
  'list',
  'bullet',
  'indent',
  'link',
  'image',
];
const channels = [
  { value: "WebsiteDirectLine", label: "Website" },
  { value: "FacebookDirectLine", label: "Facebook" },
  { value: "InstagramDirectLine", label: "Instagram" },
  { value: "WhatsApp", label: "WhatsApp" },
  { value: "WeChat", label: "WeChat" },
  { value: "PhoneSuite", label: "Voice" },
  { value: "EmailDirectLine", label: "Email" },
  { value: "TeamsApp", label: "Teams" }
];
const TWILIOCHANNEL_URL = process.env.REACT_APP_CHAT_API + '/twiliochannels';
const TWILIO_URL = process.env.REACT_APP_CHAT_API + '/twilio';
const STOPFB_URL = process.env.REACT_APP_CHAT_API + '/stopfb';
const RESUMEFB_URL = process.env.REACT_APP_CHAT_API + '/resumefb';

const TWILIO_TOKEN_GEN_URL = process.env.REACT_APP_CHAT_API + '/twilio-token';
const TWILIO_END_CONVERSATION =
  process.env.REACT_APP_CHAT_API + '/endTwilioConversation';
const TWILIO_END_CHANNELCONVERSATION =
  process.env.REACT_APP_CHAT_API + '/endTwilioChannel';
const TicketTypeOptions = [
  { value: 'LeaveDetails', label: 'Booking Desk' },
  { value: 'Conference', label: 'Event/Conference Enquiries' },
  { value: 'FrontDeskTickets', label: 'Front Desk' },
  { value: 'GroupBooking', label: 'Group Booking Enquiries' },
  { value: 'LongStay', label: 'Long Stay Enquiries' },
  { value: 'MissingResponses', label: 'Missing Responses' },
  { value: 'FoodBeverage', label: 'Food & Beverage' },
];
const StatusOptionMissed = [
  { value: 'AssignBusiness', label: 'Assign to Business' },
  { value: 'AssignBookmebob', label: 'Assign to Myma.ai' },
];
const StatusOptions = [
  { value: 'open', label: 'Open' },
  { value: 'Pending', label: 'Assigned' },
  { value: 'solved', label: 'Solved' },
  { value: 'Escalated', label: 'Escalated' },
];
class AllConversation extends Component {
  constructor(props) {
    super(props);
    this.state = this.state = {
      startDate: moment().subtract(
        this.props.location !== undefined &&
          this.props.location.state !== undefined &&
          this.props.location.state !== null &&
          this.props.location.state.date != undefined &&
          this.props.location.state.date != null
          ? this.props.location.state.date
          : 2,
        'days'
      ),
      // endDate: moment(),
      endDate: moment().add(1, 'days'),
      hotel: {},
      embeddedDate: moment(),
      items: 50,
      code: {},
      topicName: {},
      offset: 0,
      loading: false,
      data: [],
      activeIndex: -1,
      ticketTitle: '',
      ticketComments: '',
      ticketAssignTo: '',
      ticketCategory: '',
      forceRefresh: false,
      ticketSelectedCategory: [],
      ticketSelectedStatus: [],
      isOncall: false,
      showNewOptions: false,
      newTwilioChatId: '',
      ticketType: null,
      ticketPriority: null,
      popupProperty: null,
      isVisibleTicketBtn: false,
      selectedChat: null,
      isLoading: false,
      showDialPad: false,
      isLoadmore: true,
      twilioLoaded: true,
      showLoadMoreBtn: false,
      isFiltering: false,
      showTwilioConversationList: false,
      twilioToken: '',
      agentConversations: [],
      waitingConversations: [],
      chatBotConversations: [],
      twilioConversations: [],
      transfertobot: false,
      transfertomesseger: false,
      facebookSenderName: '',
      recordingurl: '',
      transcript: '',
      channel: 'All',
      open: false,
      openEmail: false,
      whatsAppConnection: false,
      msg: [],
      chatReplyTemplates: [],
      quickReplyTemplates: [],
      statusmodal: false,
      cstatus: 'Opened',
      filterstatus: 'Opened',
      googleSenderName: '',
      rtcNumber: '',
      whatsAppSenderPhoneNumber: '',
      feedback: 'all',
      detailsTab: 'CallInfo',
      isMasked:
        sessionStorage.getItem('lock') === null
          ? 'false'
          : sessionStorage.getItem('lock'),
      selectedTopic: {},
      selectedCountry: [],
      missedResponseTitle: '',
      ticketStatus: null,
      isFilterGet: false,
      categoryList: [],
      type:
        this.props.location !== undefined &&
          this.props.location.state !== undefined &&
          this.props.location.state !== null &&
          this.props.location.state.tagName != undefined &&
          this.props.location.state.tagName != null
          ? this.props.location.state.tagName
          : undefined,
      // data: this.props.getChatList({pid:'0b999af2-e798-49ae-bac6-b00559fde7d0',items:10,offset:0})
      channelName:
        this.props.location !== undefined &&
          this.props.location.state !== null &&
          this.props.location.state !== undefined &&
          this.props.location.state.channelName != undefined &&
          this.props.location.state.channelName != null
          ? this.props.location.state.channelName
          : undefined,
      conversationSummary: null,
      isSummaryLoad: true,
      csvConversation: [],
      isTranslate: false,
      translateLang: '',
      isSocial: false,
      isEmail: false,
      isExport: false,
      exportConData: {
        fromDate: moment().subtract(1, "days"),
        toDate: moment(),
        email: this.props.email,
        channel: ""
      },
      errorMessage: "",
      selectedChannel: []
    };
    this.myChatRef = React.createRef();
    this._scrollBarRef1 = React.createRef();
    this.audio = new Audio(
      'https://bmbuiassetsprod.blob.core.windows.net/images/chat_notification.mp3'
    );
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.location !== undefined &&
      this.props.location.state != null &&
      this.props.location.state.tagName != null &&
      (prevProps.location === undefined ||
        prevProps.location.state === undefined ||
        prevProps.location.state == null ||
        this.props.location.state.tagName !== prevProps.location.state.tagName)
    ) {
      this.setState({
        type: this.props.location.state.tagName,
      });
    }
  }
  componentDidMount() {
    this.loadIntegration();
    this.handleWebRTC();
    let selectedTopic = [];
    if (this.state.type !== undefined) {
      let topicName = '';
      if (this.state.type === 'amenityQueries') {
        topicName = 'Amenity';
      } else if (this.state.type === 'bookingEnquiries') {
        topicName = 'Booking';
      } else {
        topicName = this.state.type;
      }
      var top = topic.filter((e) => e.topic === topicName);
      top.map((e) => {
        selectedTopic.push({
          value: e.topic,
          label: e.topic,
        });
      });
      this.setState({
        selectedTopic: selectedTopic,
      });
    } else {
      this.setState({
        selectedTopic: selectedTopic,
      });
    }
    let channelName = '';
    if (this.state.channelName !== undefined) {
      if (this.state.channelName === 'websiteConversation') {
        channelName = 'WebsiteDirectLine';
      } else if (this.state.channelName === 'facebookConversation') {
        channelName = 'FacebookDirectLine';
      } else if (this.state.channelName === 'googleMapsConversation') {
        channelName = 'GoogleBusinessMessage';
      }
      this.setState({ channel: channelName });
    } else {
      channelName = 'All';
    }
    //console.log(this.props.timeZone)
    //console.log(this.props.propertyId)
    moment.tz.setDefault(this.props.timeZone);
    ///Australia/Sydney
    this.setState({ isLoading: true });
    let {
      offset,
      items,
      startDate,
      endDate,
      facebookSenderName,
      googleSenderName,
      whatsAppSenderPhoneNumber,
    } = this.state;
    const start = moment(startDate).format('YYYY-MM-DD') + ' 00:00:00';
    const end = moment(endDate).format('YYYY-MM-DD') + ' 23:59:59';
    this.props.getPropertyList();
    if (this.props.email !== '') {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_TrackEvent}`,
        data: {
          eventName: 'Dashboard Conversations',
          email: this.props.email,
        },
      }).then(
        (res) => { },
        (error) => {
          console.log(error);
        }
      );
    }
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Conversations_list}?gid=${getGroupID()}&pid=${this.props.propertyId
        }&df=${start}&dt=${end}&tags=${selectedTopic.length > 0
          ? selectedTopic.map((a) => a.value).join('|')
          : '-1'
        }&offset=${offset}&limit=${items}&country=-1&facebookSenderName=${facebookSenderName}&channel=${channelName}&status=${this.state.filterstatus
        }&googleSenderName=${googleSenderName}&whatsappSenderPhoneNumber=${whatsAppSenderPhoneNumber}&userId=${getUserID()}`,
    }).then(
      (res) => {
        var csvdata = this.LoadCSV_ConversationData(
          res.data && res.data.conversations ? res.data.conversations : [],
          start,
          end
        );
        this.setState((state) => ({
          data:
            res.data && res.data.conversations ? res.data.conversations : [],
          items: res.data && res.data.pageSize ? res.data.pageSize : 0,
          offset: res.data && res.data.pageCount ? res.data.pageCount : 0,
          isLoading: false,
          csvConversation: csvdata,
        }));
        let { data } = this.state;
        if (data && data.length > 0) {
          this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
          this.props.getChat(data[0].conversationId);
        }
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_FormsCategoryList}?groupId=${getGroupID()}&propertyId=${this.props.propertyId
        }&lang=${this.props.locale}`,
    }).then((res) => {
      var category = [];
      res.data.map((l) => category.push(l));
      this.setState({ categoryList: category });
    });

    this.loadQuickTemmplates();
    //setInterval(this.RefreshConversations, 2000);
    var identityBody = {
      identity: getUserID(),
    };
    fetch(TWILIO_TOKEN_GEN_URL, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(identityBody),
    }).then((tokenResponse) => {
      tokenResponse.json().then((twilioToken) => {
        this.setState(
          { accessToken: twilioToken.accessToken },
          this.initConversations
        );
      });
    });

    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_QuickReplies_listByGroup}?groupId=${getGroupID()}&propertyId=&locale=${this.props.locale
        }`,
    }).then(
      (res) => {
        this.setState((state) => ({
          chatReplyTemplates: res.data,
        }));
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${this.props.propertyId
        }?group_id=${getGroupID()}`,
    })
      .then((res) => {
        const data = res.data;

        this.setState({
          isSocial: data.isSocialChannel || false,
          isEmail: data.isEmailAutomation || false,
        });
      })
      .catch((err) => console.error('Error fetching property:', err));
  }
  LoadCSV_ConversationData(conversationList, startDate, endDate) {
    var csvticketlist = [
      { r1: 'Conversation Summary', r2: '', r3: '', r4: '', r5: '' },
      {},
      { r1: 'Start Date :' + startDate, r2: '', r3: '', r4: '', r5: '' },
      { r1: 'End Date :' + endDate, r2: '', r3: '', r4: '', r5: '' },
      {},
      {
        r1: 'Date Time',
        r2: 'Channel',
        r3: 'Calling Number',
        r4: 'Email',
        r5: 'Duration',
      },
    ];
    conversationList.map((k) => {
      csvticketlist.push({
        r1:
          moment(k.startedUtc).format('dddd, DD MMMM YYYY') +
          ' at ' +
          moment(k.startedUtc).format('h:mm a'),
        r2: k.channel,
        r3: k.phoneNumber,
        r4: k.email,
        r5: k.duration,
      });
    });
    return csvticketlist;
  }
  loadIntegration() {
    try {
      if (
        this.props.integrations !== undefined &&
        this.props.integrations !== null &&
        this.props.integrations.filter(
          (f) =>
            f.channel === 'EmailDirectLine' &&
            f.properties?.includes(this.props.propertyId) &&
            f.disabled === false
        ).length > 0
      ) {
        let obj = this.props.integrations.filter(
          (f) =>
            f.channel === 'EmailDirectLine' &&
            f.properties?.includes(this.props.propertyId) &&
            f.disabled === false
        )[0];

        let objWhatsApp = this.props.integrations.filter(
          (f) =>
            f.channel === 'WhatsApp' &&
            f.properties?.includes(this.props.propertyId) &&
            f.disabled === false
        )[0];

        AxiosAPI({
          method: 'get',
          url: `${API_Whatsapp_Integration}/${objWhatsApp.id
            }?group_id=${getGroupID()}`,
        })
          .then((res) => {
            this.setState({ whatsAppIntegration: res.data });
          })
          .catch((err) => console.log('err', err));
      }
    } catch { }
  }

  initConversations = async () => {
    window.conversationsClient = ConversationsClient;
    this.conversationsClient = await ConversationsClient.create(
      this.state.accessToken
    );

    this.conversationsClient.on('connectionStateChanged', (state) => {
      console.log(335, state);
    });

    this.conversationsClient.on(
      'conversationUpdated',
      ({ conversation, updateReasonse }) => {
        let newConversations = [...(this.state.twilioConversations || [])];
        if (
          this.state?.twilioConversations &&
          this.state.twilioConversations.length === 0
        ) {
          if (
            this.state.twilioConversations.filter(
              (f) => f.sid === conversation.sid
            ).length === 0
          )
            newConversations = [
              ...(this.state.twilioConversations || []),
              conversation,
            ];
        } else {
          newConversations = [
            ...(this.state.twilioConversations || []),
            conversation,
          ];
        }
        this.setState({ twilioConversations: newConversations });
        if (
          this.props.chatListApp.selectedchat !== undefined &&
          this.props.chatListApp.selectedchat !== null
        ) {
          if (
            this.props.chatListApp.selectedchat.twilioChatId ===
            conversation.sid
          ) {
            this.setState({ forceRefresh: true });
          }
        }
      }
    );

    this.conversationsClient.on('conversationJoined', (conversation) => {
      let newConversations = [...(this.state.twilioConversations || [])];
      if (
        this.state?.twilioConversations &&
        this.state.twilioConversations.length === 0
      ) {
        if (
          this.state.twilioConversations.filter(
            (f) => f.sid === conversation.sid
          ).length === 0
        )
          newConversations = [
            ...(this.state.twilioConversations || []),
            conversation,
          ];
      } else {
        newConversations = [
          ...(this.state.twilioConversations || []),
          conversation,
        ];
      }

      this.setState({ twilioConversations: newConversations });
      if (
        this.props.chatListApp.selectedchat !== undefined &&
        this.props.chatListApp.selectedchat !== null
      ) {
        if (
          this.props.chatListApp.selectedchat.twilioChatId === conversation.sid
        ) {
          this.setState({ forceRefresh: true });
        }
      }
    });

    this.conversationsClient.on('conversationLeft', (thisConversation) => {
      console.log('conversationLeft');
      this.setState({
        twilioConversations: [
          ...(this.state.twilioConversations || []).filter(
            (it) => it !== thisConversation
          ),
        ],
      });
    });
    // if (
    //   this.props.location !== undefined &&
    //   this.props.location.state !== undefined &&
    //   this.props.location.state.incomingchatId !== undefined
    // ) {
    //   this.acceptChat(this.props.location.state.incomingchatId);
    // }
  };

  isValidJSON(str) {
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  componentWillReceiveProps(props) {
    if (
      props.chatListApp.selectedchat !== this.props.chatListApp.selectedchat
    ) {
      var consummary =
        props.chatListApp.selectedchat.conversationSummary !== null
          ? props.chatListApp.selectedchat?.conversationSummary
            ?.assistantResponse
          : null;

      if (props.chatListApp.selectedchat !== undefined) {
        let chat = props.chatListApp.selectedchat;
        let messages = chat.messages.filter((f) => f.source === 'Visitor');
        let lst = messages[messages.length - 1];

        if (
          chat.channel === 'WhatsApp' &&
          lst !== undefined &&
          moment().diff(moment(lst.time), 'hours') <= 24
        )
          this.setState({ isLatestConversation: true });
        else this.setState({ isLatestConversation: false });
      }

      this.setState({
        selectedChat: props.chatListApp.selectedchat,
        cstatus: props.chatListApp.selectedchat.status,
        conversationSummary: this.isValidJSON(consummary)
          ? JSON.parse(consummary)
          : consummary,
        twilioChatId: props.chatListApp.selectedchat.twilioChatId,
        isSummaryLoad: false,
      });
      if (
        props.chatListApp.selectedchat.visitor &&
        props.chatListApp.selectedchat.visitor.contactId
      ) {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_TicketsRecording_id}?contactid=${props.chatListApp.selectedchat.visitor.contactId}`,
        }).then(
          (urlres) => {
            this.setState({
              recordingurl: urlres.data.url,
              //selectedChat: res.data,
              transcript: urlres.data.transcript,
            });
          },
          (error) => {
            console.log(error);
          }
        );
      } else {
        this.setState({
          recordingurl: '',
          // selectedChat: res.data,
          transcript: '',
        });
      }
    }
    // console.log('props.signalRConnectio', props.signalRConnection);
    if (
      props.signalRConnection !== undefined &&
      props.signalRConnection.newConnection !== undefined &&
      this.props.signalRConnection.newConnection === undefined
    ) {
      props.signalRConnection.newConnection.connection.on(
        'newChatUserMessage',
        this.newChatMessage
      );
      props.signalRConnection.newConnection.connection.on(
        'newChat',
        this.newChat
      );
    }

    if (
      props.signalRConnection !== undefined &&
      props.signalRConnection.isAgent !== undefined
    ) {
      this.setState({ agentAccess: props.signalRConnection.isAgent });
    }
  }

  loadQuickTemmplates = () => {
    if (this.props.propertyId != '-1') {
      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_QuickReplies}?groupId=${getGroupID()}&propertyId=${this.props.propertyId
          }&locale=${this.props.locale}`,
      }).then(
        (res) => {
          this.setState((state) => ({
            quickReplyTemplates: res.data,
          }));
        },
        (error) => {
          this.setState({ loading: false, error, isLoading: false });
        }
      );
    }
  };
  handleMaskClick = () => {
    if (sessionStorage.getItem('lock') === 'true') {
      sessionStorage.setItem('lock', 'false');
      this.setState({ isMasked: 'false' });
    } else {
      sessionStorage.setItem('lock', 'true');
      this.setState({ isMasked: 'true' });
    }
  };
  handleContactClick = (index, userId) => {
    this.setState({ activeIndex: index, isVisibleTicketBtn: true });
    const chat = this.props.getChat(userId);
  };

  handleChangeDate = (date) => {
    this.setState({
      startDate: date,
    });
  };

  handleChangeEndDate = (date) => {
    this.setState({
      endDate: date,
    });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleExportInputChange = (e) => {
    var data = { ...this.state.exportConData };
    const { name, value } = e.target;
    if (name === "email") {
      data.email = value;
    }
    else if (name === "channel") {
      data.channel = value;
    }
    this.setState({ exportConData: data });
  };
  handleExportDateChange = (date, field) => {
    var data = { ...this.state.exportConData };
    if (field === "from") {
      data.fromDate = date;
    } else {
      data.toDate = date;
    }
    if (data.fromDate && data.toDate) {
      var isvalid = this.checkDateRange(data.fromDate, data.toDate);
      if (isvalid) {
        this.setState({ exportConData: data });
      }
    }

  }
  checkDateRange = (fromDate, toDate) => {
    const start = new Date(fromDate);
    const end = new Date(toDate);

    const timeDiff = Math.abs(end - start); // Time difference in milliseconds
    const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24)); // Convert ms to days
    if (daysDiff < 365) {
      this.setState({ errorMessage: "" });
      return true;

    } else {
      this.setState({ errorMessage: "you can't select more then one year date range !!" });
      return false;
    }
  }
  handleChangeMulti = (selectedOptions) => {
    this.setState({ selectedChannel: selectedOptions });
    const categoriesArr = selectedOptions.map((elem) => elem.value);
    var data = { ...this.state.exportConData };
    data.channel = categoriesArr.join(',');
    this.setState({ exportConData: data });
  };
  handleSubmitRequest = () => {
    var isvalid = this.checkDateRange(this.state.exportConData.fromDate, this.state.exportConData.toDate);
    var body = {
      groupId: getGroupID(),
      propertyId: this.props.propertyId,
      fromDate: moment(this.state.exportConData.fromDate).format("DD-MM-YYYY"),
      toDate: moment(this.state.exportConData.toDate).format("DD-MM-YYYY"),
      email: this.state.exportConData.email,
      channel: this.state.exportConData.channel,
      createdBy: this.props.userName
    }
    if (isvalid) {
      AxiosAPI({
        method: 'post',
        url: `${postAPI_CreateExportReport}`,
        data: body,
      }).then(
        (res) => {
          this.setState({ isExport: false })
        },
        (error) => { }
      );
    }
  }
  handleStatusSubmit = (status) => {
    const id = this.state.selectedChat.conversationId;

    if (
      status === 'Closed' &&
      this.state.twilioChatId &&
      this.state.twilioChatId !== ''
    ) {
      AxiosAPI({
        method: 'put',
        url: `${putAPI_ConversationsStatus_By_Id}/${this.state.selectedChat.conversationId}`,
        data: {
          groupId: this.state.selectedChat.groupId,
          status: status,
          sessionId: this.state?.selectedChat?.sessionId,
        },
      }).then(
        (res) => {
          if (this.state.filterstatus !== 'All') {
            const newList = this.state.data.filter(
              (item) => item.conversationId !== id
            );
            this.setState({ data: newList });
            if (newList.length > 0) {
              this.props.getChat(newList[0].conversationId);
            } else {
              this.setState({ selectedChat: null });
            }
          } else {
            this.props.getChat(id);
          }
          //Close Twilio Conversation

          this.closeTwilioConversation(
            this.state.twilioChatId,
            this.state.selectedChat.conversationId,
            this.state.selectedChat.channel
          );
        },
        (error) => { }
      );
    } else {
      AxiosAPI({
        method: 'put',
        url: `${putAPI_ConversationsStatus_By_Id}/${this.state.selectedChat.conversationId}`,
        data: {
          groupId: this.state.selectedChat.groupId,
          status: status,
          sessionId: this.state?.selectedChat?.sessionId,
        },
      }).then(
        (res) => {
          if (this.state.filterstatus !== 'All') {
            const newList = this.state.data.filter(
              (item) => item.conversationId !== id
            );
            this.setState({ data: newList });
            if (newList.length > 0) {
              this.props.getChat(newList[0].conversationId);
            } else {
              this.setState({ selectedChat: null });
            }
          } else {
            // const objIndex = this.state.data.findIndex(
            //   (obj) => obj.conversationId == id
            // );
            // const myArray = this.state.data;
            // console.log(myArray[objIndex]);
            // myArray[objIndex].status = this.state.cstatus;
            // this.setState({ data: myArray });
            this.props.getChat(id);
          }
          // const conversation = this.state.data.filter(
          //   (m) => m.conversationId === id
          // );
          // if (conversation.length > 0) {
          //   conversation[0].status = this.state.cstatus;
          // }
          //this.statustoggle();
        },
        (error) => { }
      );
    }
  };

  loadMoreConversations = () => {
    this.setState({
      isLoadmore: true,
      isLoading: true,
    });
    let {
      items,
      hotel,
      startDate,
      endDate,
      code,
      topicName,
      googleSenderName,
      whatsAppSenderPhoneNumber,
    } = this.state;
    startDate = startDate
      ? moment(startDate).format('YYYY-MM-DD') + ' 00:00:00'
      : '';
    endDate = endDate ? moment(endDate).format('YYYY-MM-DD') + ' 23:59:59' : '';

    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Conversations_list}?gid=${getGroupID()}&country=${code.length > 0 ? code.map((a) => a.value).join('|') : '-1'
        }&tags=${topicName.length > 0 ? topicName.map((a) => a.value).join('|') : '-1'
        }&pid=${this.props.propertyId}&df=${startDate}&dt=${endDate}&offset=${this.state.offset
        }&limit=${items}&facebookSenderName=${this.state.facebookSenderName
        }&channel=${this.state.channel}&status=${this.state.filterstatus
        }&googleSenderName=${googleSenderName}&whatsappSenderPhoneNumber=${whatsAppSenderPhoneNumber}&userId=${getUserID()}`,
    }).then(
      (res) => {
        var csvdata = this.LoadCSV_ConversationData(
          res.data.conversations,
          startDate,
          endDate
        );
        this.setState((state) => ({
          data: [...state.data, ...res.data.conversations],
          items: res.data.pageSize,
          offset: res.data.pageCount,
          isLoading: false,
          csvConversation: csvdata,
        }));
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  };

  handleChangeFB = (e) => {
    const { name, value } = e.target;
    this.setState({ facebookSenderName: value });

    if (value.length >= 3 || value.length === 0) {
      this.setState({
        isLoadmore: true,
        isLoading: true,
        isVisibleTicketBtn: false,
        data: [],
        selectedChat: null,
        activeIndex: -1,
      });
      let {
        items,
        hotel,
        startDate,
        endDate,
        code,
        topicName,
        googleSenderName,
        whatsAppSenderPhoneNumber,
      } = this.state;

      startDate = startDate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
      endDate = endDate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';

      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Conversations_list}?gid=${getGroupID()}&country=${code.length > 0 ? code.map((a) => a.value).join('|') : '-1'
          }&tags=${topicName.length > 0 ? topicName.map((a) => a.value).join('|') : '-1'
          }&pid=${this.props.propertyId
          }&df=${startDate}&dt=${endDate}&offset=0&limit=${items}&facebookSenderName=${value}&channel=${this.state.channel
          }&status=${this.state.filterstatus
          }&googleSenderName=${googleSenderName}&whatsappSenderPhoneNumber=${whatsAppSenderPhoneNumber}&userId=${getUserID()}`,
      }).then(
        (res) => {
          var csvdata = this.LoadCSV_ConversationData(
            res.data.conversations,
            startDate,
            endDate
          );
          this.setState((state) => ({
            data: res.data.conversations,
            items: res.data.pageSize,
            offset: res.data.pageCount,
            isLoading: false,
            csvConversation: csvdata,
          }));
          let { data } = this.state;
          if (data.length > 0) {
            this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
            this.props.getChat(data[0].conversationId);
          }
        },
        (error) => {
          this.setState({ loading: false, error, isLoading: false });
        }
      );
    }
  };

  handleChangeGoogle = (e) => {
    const { name, value } = e.target;
    this.setState({ googleSenderName: value });

    if (value.length >= 3 || value.length === 0) {
      this.setState({
        isLoadmore: true,
        isLoading: true,
        isVisibleTicketBtn: false,
        data: [],
        selectedChat: null,
        activeIndex: -1,
      });
      let {
        items,
        hotel,
        startDate,
        endDate,
        code,
        topicName,
        facebookSenderName,
        whatsAppSenderPhoneNumber,
      } = this.state;

      startDate = startDate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
      endDate = endDate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';

      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Conversations_list}?gid=${getGroupID()}&country=${code.length > 0 ? code.map((a) => a.value).join('|') : '-1'
          }&tags=${topicName.length > 0 ? topicName.map((a) => a.value).join('|') : '-1'
          }&pid=${this.props.propertyId
          }&df=${startDate}&dt=${endDate}&offset=0&limit=${items}&facebookSenderName=${facebookSenderName}&channel=${this.state.channel
          }&status=${this.state.filterstatus
          }&googleSenderName=${value}&whatsappSenderPhoneNumber=${whatsAppSenderPhoneNumber}&userId=${getUserID()}`,
      }).then(
        (res) => {
          var csvdata = this.LoadCSV_ConversationData(
            res.data.conversations,
            startDate,
            endDate
          );
          this.setState((state) => ({
            data: res.data.conversations,
            items: res.data.pageSize,
            offset: res.data.pageCount,
            isLoading: false,
            csvConversation: csvdata,
          }));
          let { data } = this.state;
          if (data.length > 0) {
            this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
            this.props.getChat(data[0].conversationId);
          }
        },
        (error) => {
          this.setState({ loading: false, error, isLoading: false });
        }
      );
    }
  };

  handleChangeWhatsApp = (e) => {
    const { name, value } = e.target;
    this.setState({ whatsAppSenderPhoneNumber: value });

    if (value.length >= 3 || value.length === 0) {
      this.setState({
        isLoadmore: true,
        isLoading: true,
        isVisibleTicketBtn: false,
        data: [],
        selectedChat: null,
        activeIndex: -1,
      });
      let {
        items,
        hotel,
        startDate,
        endDate,
        code,
        topicName,
        facebookSenderName,
        googleSenderName,
      } = this.state;

      startDate = startDate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
      endDate = endDate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';

      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Conversations_list}?gid=${getGroupID()}&country=${code.length > 0 ? code.map((a) => a.value).join('|') : '-1'
          }&tags=${topicName.length > 0 ? topicName.map((a) => a.value).join('|') : '-1'
          }&pid=${this.props.propertyId
          }&df=${startDate}&dt=${endDate}&offset=0&limit=${items}&facebookSenderName=${facebookSenderName}&channel=${this.state.channel
          }&status=${this.state.filterstatus
          }&googleSenderName=${googleSenderName}&whatsappSenderPhoneNumber=${value}&userId=${getUserID()}`,
      }).then(
        (res) => {
          var csvdata = this.LoadCSV_ConversationData(
            res.data.conversations,
            startDate,
            endDate
          );
          this.setState((state) => ({
            data: res.data.conversations,
            items: res.data.pageSize,
            offset: res.data.pageCount,
            isLoading: false,
            csvConversation: csvdata,
          }));
          let { data } = this.state;
          if (data.length > 0) {
            this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
            this.props.getChat(data[0].conversationId);
          }
        },
        (error) => {
          this.setState({ loading: false, error, isLoading: false });
        }
      );
    }
  };
  handleChangeSelect = (value, { name }) => {
    if (name === 'topicName') {
      this.setState({
        selectedTopic: value,
      });
    } else if (name === 'code') {
      this.setState({
        selectedCountry: value,
      });
    }
    this.setState({
      [name]: value,
    });
  };

  handleNotes = (source, e) => {
    if (source === 'user') this.setState({ ticketComments: e });
  };

  handleChangeMultiCategory = (category) => {
    var cate = [];
    cate.push(category);
    this.setState({
      ticketCategory: [category.value],
      ticketTitle: category.value,
      ticketSelectedCategory: cate,
    });
  };
  handleStatus = (category) => {
    var cate = [];
    cate.push(category);
    this.setState({
      ticketStatus: category.value,
      ticketSelectedStatus: cate,
    });
  };
  statustoggle = () => {
    this.setState((prevState) => ({
      statusmodal: !prevState.statusmodal,
    }));
  };

  toggle = () => {
    var selectedProperty =
      this.props.usersListApp.properties !== undefined
        ? this.props.usersListApp.properties
          .filter((elem) => elem.id === this.props.propertyId)
          .map((pro) => {
            return { label: pro.name, value: pro.id };
          })[0]
        : null;
    this.setState((prevState) => ({
      modal: !prevState.modal,
      ticketStatus: 'Pending',
      ticketSelectedStatus: [{ label: 'Assigned', value: 'Pending' }],
      popupProperty: selectedProperty,
    }));
  };

  toggleMessanger = () => {
    this.setState((prevState) => ({
      transfertomesseger: !prevState.transfertomesseger,
    }));
  };

  togglebot = () => {
    this.setState((prevState) => ({
      transfertobot: !prevState.transfertobot,
    }));
  };

  //NO need to refresh
  RefreshConversations = () => {
    let {
      items,
      hotel,
      startDate,
      endDate,
      code,
      topicName,
      facebookSenderName,
      googleSenderName,
      whatsAppSenderPhoneNumber,
    } = this.state;
    startDate = startDate ? startDate.format('YYYY-MM-DD') + ' 00:00:00' : '';
    endDate = endDate ? endDate.format('YYYY-MM-DD') + ' 23:59:59' : '';
    if (
      moment(endDate).utc().format('YYYY-MM-DD') ===
      moment().utc().format('YYYY-MM-DD')
    ) {
      let utcDate = moment().utc();

      AxiosAPI({
        methhod: 'get',
        url: `${gAPI_Conversations_list}?gid=${getGroupID()}&country=${code.length > 0 ? code.map((a) => a.value).join('|') : '-1'
          }&tags=${topicName.length > 0 ? topicName.map((a) => a.value).join('|') : '-1'
          }&pid=${this.props.propertyId}&df=${moment()
            .utc()
            .subtract(1, 'minutes')
            .format('YYYY-MM-DD HH:mm:ss')}&dt=${moment()
              .utc()
              .format(
                'YYYY-MM-DD HH:mm:ss'
              )}&offset=0&limit=${items}&facebookSenderName=${facebookSenderName}&googleSenderName=${googleSenderName}&whatsappSenderPhoneNumber=${whatsAppSenderPhoneNumber}&channel=${this.state.channel
          }&status=${this.state.filterstatus}&userId=${getUserID()}`,
      }).then(
        (res) => {
          //console.log(res.data.conversations)
          this.audio.play();
          //   var newcConversations = [this.state.data].concat(res.data.conversations)
          // console.log(newcConversations)
          var csvdata = this.LoadCSV_ConversationData(
            res.data.conversations,
            moment().utc().subtract(1, 'minutes').format('YYYY-MM-DD HH:mm:ss'),
            moment().utc().format('YYYY-MM-DD HH:mm:ss')
          );
          this.setState((state) => ({
            data: this.state.data.concat(res.data.conversations),
            csvConversation: csvdata,
          }));
        },
        (error) => {
          this.setState({ loading: false, error, isLoading: false });
        }
      );
    }
  };

  handleSubmitClick = () => {
    this.setState({
      isLoadmore: true,
      isLoading: true,
      isVisibleTicketBtn: false,
      data: [],
      selectedChat: null,
      activeIndex: -1,
      isFiltering: false,
      isFilterGet: false,
    });
    let {
      items,
      hotel,
      startDate,
      endDate,
      code,
      topicName,
      facebookSenderName,
      googleSenderName,
      whatsAppSenderPhoneNumber,
      feedback,
    } = this.state;

    startDate = startDate
      ? moment(startDate).format('YYYY-MM-DD') + ' 00:00:00'
      : '';
    endDate = endDate ? moment(endDate).format('YYYY-MM-DD') + ' 23:59:59' : '';

    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Conversations_list}?gid=${getGroupID()}&country=${code.length > 0 ? code.map((a) => a.value).join('|') : '-1'
        }&tags=${topicName.length > 0 ? topicName.map((a) => a.value).join('|') : '-1'
        }&pid=${this.props.propertyId
        }&df=${startDate}&dt=${endDate}&offset=0&limit=${items}&facebookSenderName=${facebookSenderName}&channel=${this.state.channel
        }&status=${this.state.filterstatus
        }&googleSenderName=${googleSenderName}&whatsappSenderPhoneNumber=${whatsAppSenderPhoneNumber}&feedback=${feedback}&userId=${getUserID()}`,
    }).then(
      (res) => {
        var csvdata = this.LoadCSV_ConversationData(
          res.data.conversations,
          startDate,
          endDate
        );
        this.setState((state) => ({
          data: res.data.conversations,
          items: res.data.pageSize,
          offset: res.data.pageCount,
          isLoading: false,
          csvConversation: csvdata,
        }));
        let { data } = this.state;
        if (data.length > 0) {
          this.setState({ activeIndex: 0, isVisibleTicketBtn: true });
          this.props.getChat(data[0].conversationId);
        } else {
          this.setState({ isFilterGet: true });
        }
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  };

  toggleTwillioConversation = () => {
    this.setState({
      showTwilioConversationList: !this.state.showTwilioConversationList,
    });
  };

  twilioStartChat = () => {
    this.setState({
      showTwilioConversationList: true,
    });
  };

  // twilioMakingConnection = (
  //   botConversationId,
  //   location,
  //   ipAddress,
  //   botCoversationMessages
  // ) => {
  //   AxiosAPI({
  //     method: 'get',
  //     url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
  //   }).then((userData) => {
  //     let requestBody = {
  //       conversationId: botConversationId,
  //       bmbUser: getUserID(),
  //       location: location,
  //       ipAddress: ipAddress,
  //       welcomeMessage: `Agent ${userData.data.fullName} has joined`,
  //     };
  //     //console.log("botConversationId", botConversationId)
  //     AxiosPublicAPI({
  //       method: 'post',
  //       url: `${TWILIO_URL}`,
  //       data: requestBody,
  //     }).then(
  //       (res) => {
  //         if (res.data.twilioConversationId !== undefined) {
  //           AxiosAPI({
  //             method: 'put',
  //             url: `${putAPI_ConversationsTwilioStart}/${this.state.selectedChat.conversationId}`,
  //             data: {
  //               groupId: getGroupID(),
  //               twilioChatId: res.data.twilioConversationId,
  //             },
  //           }).then((d) => { });
  //           this.twilioStartChat();
  //         }
  //       },
  //       (error) => {
  //         console.log(error);
  //       }
  //     );
  //   });
  // };

  StopFacebookChat = (botConversationId) => {
    console.log(botConversationId);
    AxiosPublicAPI({
      method: 'get',
      url: `${STOPFB_URL}/${botConversationId}`,
    }).then((userData) => {
      console.log('stop FB');
      this.toggleMessanger();
      AxiosAPI({
        method: 'put',
        url: `${putAPI_ConversationsFacebookTransfer}/${this.state.selectedChat.conversationId}`,
        data: {
          groupId: getGroupID(),
          transfer: true,
        },
      }).then((d) => { });
    });
  };

  ResumeFacebookChat = (botConversationId) => {
    AxiosPublicAPI({
      method: 'get',
      url: `${RESUMEFB_URL}/${botConversationId}`,
    }).then((userData) => {
      console.log('resume FB');
      this.togglebot();
      AxiosAPI({
        method: 'put',
        url: `${putAPI_ConversationsFacebookTransfer}/${this.state.selectedChat.conversationId}`,
        data: {
          groupId: getGroupID(),
          transfer: false,
        },
      }).then((d) => { });
    });
  };

  handleTicketSubmit = () => {
    const {
      ticketTitle,
      ticketCategory,
      ticketAssignTo,
      ticketComments,
      ticketType,
      ticketStatus,
      missedResponseTitle,
      popupProperty,
      selectedChat,
    } = this.state;
    let tickets = [];
    //ticketType && ticketType.map((ticket) => tickets.push(ticket.value));
    var statusNotes = [];
    if (ticketStatus === 'Pending') {
      statusNotes.push({
        assignEmail: ticketAssignTo,
        text: 'Assigned to ' + ticketAssignTo,
        createdBy: this.props.email,
      });
    }
    statusNotes.push({
      assignEmail: '',
      text: 'Ticket created by ' + this.props.email,
      createdBy: this.props.email,
    });
    const data = {
      notes: ticketComments,
      tags: ticketCategory,
      creator: 'Dashboard',
      Source: 'BobDashboard',
      conversationId: selectedChat.botConversationId,
      propertyId: popupProperty && popupProperty.value,
      groupId: selectedChat.groupId,
      status: ticketStatus,
      type: ticketType,
      title: ticketTitle,
      assignTo: ticketAssignTo,
      statusNotes: statusNotes,
    };

    if (ticketType === 'MissingResponses') {
      if (missedResponseTitle !== null && missedResponseTitle !== '') {
        data.requesterName = missedResponseTitle;
      }
    }
    AxiosAPI({
      method: 'post',
      url: `${postAPI_Create_Ticket}/dashboard`,
      data,
    })
      .then((res) => {
        if (
          res.data.HttpStatusCode !== undefined &&
          res.data.HttpStatusCode === 400 &&
          res.data.Messages !== undefined &&
          res.data.Messages !== null &&
          res.data.Messages.length > 0
        ) {
          this.setState({ msg: res.data.Messages });
          this.setState({ open: true });
        } else this.toggle();
      })
      .catch((err) => {
        console.log('err', err);
      });
  };
  TwiloConversation = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="12" className="mb-1">
              <Modal
                isOpen={this.state.showTwilioConversationList}
                keyboard="false"
                backdrop="static"
                toggle={this.toggleTwillioConversation}
                size="lg"
                style={{ maxWidth: '1000px' }}
              >
                <ModalBody>
                  <TwilioConversationApp
                    userId={getUserID()}
                    twilioStartChat={this.twilioStartChat}
                  />
                </ModalBody>
                <ModalFooter>
                  <Button
                    color="primary"
                    onClick={this.toggleTwillioConversation}
                  >
                    Close
                  </Button>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  TransferBotToMessanger = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="12" className="mb-1">
              <Modal
                isOpen={this.state.transfertomesseger}
                keyboard="false"
                backdrop="static"
                toggle={this.toggleMessanger}
              >
                <ModalHeader>Handover to Messenger</ModalHeader>
                <ModalBody>
                  <p>
                    {' '}
                    Chatbot will stop responding to the user messages, and you
                    will need to respond from the Facebook Messenger app. You
                    can anytime give control back to the chatbot for this
                    Facebook user.{' '}
                  </p>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={this.toggleMessanger}>
                    Continue
                  </Button>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  TransferToBot = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
          <Row>
            <Colxx xs="12" sm="12" className="mb-1">
              <Modal
                isOpen={this.state.transfertobot}
                keyboard="false"
                backdrop="static"
                toggle={this.togglebot}
              >
                <ModalHeader>Handover to Chatbot</ModalHeader>
                <ModalBody>
                  <p>
                    {' '}
                    Chatbot will start responding to this user messages. You can
                    anytime take control back from the chatbot for this Facebook
                    user.
                  </p>
                </ModalBody>
                <ModalFooter>
                  <Button color="primary" onClick={this.togglebot}>
                    Continue
                  </Button>
                </ModalFooter>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  handleWebRTC = () => {
    if (
      this.props.integrations !== undefined &&
      this.props.integrations !== null &&
      this.props.integrations.filter(
        (f) =>
          f.channel === 'WebRTC' &&
          f.properties?.includes(this.props.propertyId) &&
          f.disabled === false
      ).length > 0
    ) {
      AxiosAPI({
        method: 'get',
        url: `${API_Web_RTC}/${this.props.integrations.filter(
          (f) =>
            f.channel === 'WebRTC' &&
            f.properties?.includes(this.props.propertyId) &&
            f.disabled === false
        )[0].id
          }?group_id=${getGroupID()}`,
      }).then((res) => {
        if (res.data.webRTCIntegration !== undefined) {
          this.setState({ webRTCIntegration: res.data.webRTCIntegration });
        }
      });
    }
  };

  getVisitorNameDetail = () => {
    if (this.state.selectedChat !== undefined) {
      let channel = this.state.selectedChat?.channel;
      let visitor = this.state.selectedChat?.visitor;

      let name = '';
      if (visitor !== undefined) {
        if (channel !== undefined && channel === 'PhoneSuite') {
          return (
            <span className="ml-1 mt-1" style={{ width: '20%', fontSize: '12px', lineHeight: '10px' }}>
              {visitor.nmsAni}
            </span>
          );
        } else if (channel !== undefined && channel === 'EmailDirectLine') {
          return <span className="ml-1" style={{ width: '32%', }}></span>;
        } else if (channel !== undefined && channel === 'TeamsApp') {
          return (
            <span className="ml-1 mt-1" style={{ width: '32%', fontSize: '12px', lineHeight: '10px' }}>
              {visitor?.teamSender}
            </span>
          );
        } else if (channel !== undefined && channel === 'TeamsApp') {
          return <span className="ml-1" style={{ width: '32%' }}></span>;
        } else {
          let startTime = moment().format('YYYY-MM-DD h:mm a');
          let endTime = moment(this.state.selectedChat.startedUtc).format(
            'YYYY-MM-DD h:mm a'
          );
          let hoursDiff = moment(startTime).diff(endTime, 'hours');
          if (
            visitor?.name &&
            visitor.name !== null &&
            visitor.name !== '' &&
            hoursDiff > 24
          )
            return (
              <span className="ml-1" style={{ width: '32%', fontSize: '12px', lineHeight: '10px' }}>
                {visitor.name}
              </span>
            );
          else if (
            visitor?.email &&
            visitor.email !== null &&
            visitor.email !== '' &&
            hoursDiff > 24
          )
            return (
              <span className="ml-1" style={{ width: '32%', fontSize: '12px', lineHeight: '10px' }}>
                {visitor.email}
              </span>
            );
          else if (
            visitor?.phoneNumber &&
            visitor.phoneNumber !== null &&
            visitor.phoneNumber !== '' &&
            hoursDiff > 24
          )
            return (
              <span className="ml-1" style={{ width: '32%', fontSize: '12px', lineHeight: '10px' }}>
                {visitor.phoneNumber}
              </span>
            );
          else if (
            visitor?.location &&
            visitor.location !== null &&
            visitor.location !== '' &&
            hoursDiff > 24
          )
            return (
              <span className="ml-1" style={{ width: '32%', fontSize: '12px', lineHeight: '10px' }}>
                {visitor.location}
              </span>
            );
        }
      }
    }
    return <span className="ml-1" style={{ width: '32%' }}></span>;
  };

  getVisitorOnlineDetail = () => {
    if (this.state.selectedChat !== undefined) {
      let channel = this.state.selectedChat?.channel;
      let visitor = this.state.selectedChat?.visitor;
      let hoursDiff = 0;
      if (visitor !== undefined) {
        let startTime = moment().format('YYYY-MM-DD h:mm a');
        let endTime = moment(this.state.selectedChat.startedUtc).format(
          'YYYY-MM-DD h:mm a'
        );
        hoursDiff = moment(startTime).diff(endTime, 'hours');
        let minDiff = moment(startTime).diff(endTime, 'minutes');
        if (channel !== undefined && channel === 'PhoneSuite') {
          if (hoursDiff === 0) {
            if (minDiff <= 0) {
              return (
                <p
                  className="ml-1 mt-2"
                  style={{ position: 'absolute', top: '35px', fontSize: '10px' }}
                >
                  Active an minute ago
                </p>
              );
            } else {
              return (
                <p
                  className="ml-1 mt-2"
                  style={{ position: 'absolute', top: '35px', fontSize: '10px' }}
                >
                  Active {minDiff} minutes ago
                </p>
              );
            }
          }
          if (hoursDiff <= 1) {
            return (
              <p
                className="ml-1 mt-2"
                style={{ position: 'absolute', top: '35px', fontSize: '10px' }}
              >
                Called an hour ago
              </p>
            );
          } else if (hoursDiff <= 24) {
            return (
              <p
                className="ml-1 mt-2"
                style={{ position: 'absolute', top: '35px', fontSize: '10px' }}
              >
                Called {hoursDiff} hours ago
              </p>
            );
          } else {
            return '';
          }
        } else if (channel !== undefined && channel === 'EmailDirectLine') {
          return (
            <Fragment>
              <span
                className="ml-1 mt-2"
                style={{ width: '30%', position: 'absolute', bottom: '0px' }}
              >
                {visitor.subject}
              </span>
            </Fragment>
          );
        } else {
          if (hoursDiff === 0) {
            if (minDiff <= 0) {
              return (
                <p
                  className="ml-1 mt-2"
                  style={{ position: 'absolute', top: '35px', fontSize: '10px' }}
                >
                  Active an minute ago
                </p>
              );
            } else {
              return (
                <p
                  className="ml-1 mt-2"
                  style={{ position: 'absolute', top: '35px', fontSize: '10px' }}
                >
                  Active {minDiff} minutes ago
                </p>
              );
            }
          }
          if (hoursDiff <= 1) {
            return (
              <p
                className="ml-1 mt-1"
                style={{ position: 'absolute', top: '35px', fontSize: '10px' }}
              >
                Online an hour ago
              </p>
            );
          } else if (hoursDiff <= 24) {
            return (
              <p
                className="ml-1 mt-0"
                style={{ position: 'absolute', top: '35px', fontSize: '10px' }}
              >
                Online {hoursDiff} hours ago
              </p>
            );
          } else {
            return '';
          }
        }
      }
    }
  };

  getVisitorCallingNumber = () => {
    var chat = this.state.selectedChat;
    if (chat !== undefined) {
      var visitor = chat?.visitor;
      if (visitor !== undefined) {
        if (visitor?.nmsAni && visitor.nmsAni !== '')
          return visitor?.nmsAni ? visitor.nmsAni : '';
        else if (visitor?.phoneNumber && visitor.phoneNumber !== '')
          return visitor?.phoneNumber ? visitor.phoneNumber : '';
        else if (
          visitor?.whatsAppSenderPhoneNumber &&
          visitor.whatsAppSenderPhoneNumber !== ''
        )
          return visitor?.whatsAppSenderPhoneNumber
            ? visitor.whatsAppSenderPhoneNumber
            : '';
        else return '';
      }
      return '';
    }
    return '';
  };

  handleRTCNumber = (val) => {
    this.setState({ isOncall: true });
    this.setState({ rtcNumber: val });
  };

  handleNewCall = () => {
    this.setState({ showNewOptions: false });
    this.setState({ showDialPad: true });
  };

  twilioConnectionToUserChat = (
    botConversationId,
    location,
    ipAddress,
    conversationId,
    channel
  ) => {
    this.setState({ twilioLoaded: false });
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Users_By_Id}/${getUserID()}?gid=${getGroupID()}`,
    }).then((userData) => {
      let requestBody = {
        conversationId: botConversationId,
        bmbUser: getUserID(),
        location: location,
        ipAddress: ipAddress,
        welcomeMessage: `Agent ${userData.data.fullName} has joined`,
        channel: channel,
      };
      //console.log("botConversationId", botConversationId)
      AxiosPublicAPI({
        method: 'post',
        url: `${channel === 'WebsiteDirectLine' ? TWILIO_URL : TWILIOCHANNEL_URL
          }`,
        data: requestBody,
      }).then(
        (res) => {
          if (res.data.twilioConversationId !== undefined) {
            AxiosAPI({
              method: 'put',
              url: `${putAPI_ConversationsTwilioStart}/${conversationId}`,
              data: {
                groupId: getGroupID(),
                twilioChatId: res.data.twilioConversationId,
              },
            }).then((d) => { });
            this.setState({ newTwilioChatId: res.data.twilioConversationId });
            this.setTwilioChat();
            if (res.data.twilioConversationId !== undefined) {
              const agentIndex = this.state.data.findIndex(
                (a) => a.conversationId === conversationId
              );

              if (agentIndex > -1) {
                const updatedAgentConversations = [...this.state.data];
                updatedAgentConversations[agentIndex] = {
                  ...updatedAgentConversations[agentIndex],
                  twilioChatId: res.data.twilioConversationId,
                };

                // Keep newTwilioChatId and update the specific agent conversation
                this.setState({
                  data: updatedAgentConversations,
                });
              }
            }
            //this.twilioStartChat();
          }
        },
        (error) => {
          this.setState({ twilioLoaded: true });
          console.log(error);
        }
      );
    });

    AxiosAPI({
      method: 'put',
      url: `${putAPI_UpdateAgentStatus_By_Id}/${conversationId}`,
      data: {
        groupId: getGroupID(),
        userId: getUserID(),
        status: 'Accepted',
      },
    }).then(() => {
      //console.log('Accepted');
      const checkConversations = this.state.data.filter(
        (m) => m.conversationId === conversationId
      );
      if (checkConversations.length === 0) {
        AxiosAPI({
          methhod: 'get',
          url: `${gAPI_Conversations_By_Id}/${conversationId}/conversation?gid=${getGroupID()}`,
        }).then(
          (res) => {
            this.setState({
              agentConversations: [
                res.data,
                ...(this.state.agentConversations || []),
              ],
              activeChat: res.data.conversationId,
              conversationSummary: this.isValidJSON(
                res.data.conversationSummary.assistantResponse
              )
                ? JSON.parse(res.data.conversationSummary.assistantResponse)
                : res.data.conversationSummary.assistantResponse,
              isSummaryLoad: false,
            });
            this.props.getChat(res.data.conversationId);
            this.audio.play();
          },
          (error) => {
            this.setState({ loading: false, error, isLoading: false });
          }
        );
      } else {
        this.setState({
          agentConversations: [
            checkConversations[0],
            ...(this.state.agentConversations || []),
          ],
          activeChat: checkConversations[0].conversationId,
        });
        this.props.getChat(checkConversations[0].conversationId);
        var array = [...(this.state.chatBotConversations || [])]; // make a separate copy of the array
        // console.log(
        //   'this.state.chatBotConversations',
        //   this.state.chatBotConversations
        // );

        var index = array.findIndex((a) => a.conversationId === conversationId);
        //console.log(index);
        if (index !== -1) {
          array.splice(index, 1);
          //console.log('array', array);
          this.setState({ chatBotConversations: array });
        }
      }
    });
  };

  setBlankTwilioId = () => {
    this.setState({ twilioChatId: '' });
  };

  setTwilioChat = () => {
    let intervalId = setInterval(this.checkTwilioChatReady, 1000);
    this.setState({ intervalId: intervalId });
  };

  checkTwilioChatReady = () => {
    console.log(
      'Checking Twilio Chat Ready',
      this.props.twilioConversationsReducer
    );

    if (this.state.newTwilioChatId !== '') {
      const c = this.state.twilioConversations.filter(
        (m) => m.sid === this.state.newTwilioChatId
      );
      //  console.log(1407, c, this.state.twilioConversations);

      if (c.length > 0) {
        this.setState({ twilioChatId: c[0].sid, twilioLoaded: true });
        clearInterval(this.state.intervalId);
        if (
          this.props.twilioConversationsReducer !== undefined &&
          this.props.twilioConversationsReducer.twilioConversations !==
          undefined &&
          this.props.twilioConversationsReducer.twilioConversations.length > 0
        ) {
          const convo =
            this.props.twilioConversationsReducer.twilioConversations.filter(
              (m) => m.sid === this.state.newTwilioChatId
            );
          console.log(1419, convo);
          if (convo.length == 0) {
            this.props.pushTwilioConversations({ twilioChatId: c[0] });
          }
        } else {
          this.props.pushTwilioConversations({ twilioChatId: c[0] });
        }
      }
    }
  };

  stopBlink = () => {
    this.props.BotBlink(false);
    this.props.AgentBlink(false);
  };

  closeTwilioConversation = (sid, conversationId, channel) => {
    // if (event.target.tagName == 'svg') {
    fetch(
      `${channel === 'WebsiteDirectLine'
        ? TWILIO_END_CONVERSATION
        : TWILIO_END_CHANNELCONVERSATION
      }`,
      {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          twilioConversationId: sid,
          channel: channel,
          message: `Agent ${this.props.user && this.props.user.profile.name
            } has left the conversation`,
        }),
      }
    ).then((res) => {
      // console.log('Closed');
    });
    AxiosAPI({
      method: 'put',
      url: `${putAPI_UpdateChatStatus_By_Id}/${conversationId}`,
      data: {
        groupId: getGroupID(),
        userId: getUserID(),
        status: 'Ended',
      },
    });

    AxiosAPI({
      method: 'put',
      url: `${putAPI_ConversationsTwilioStart}/${conversationId}`,
      data: {
        groupId: getGroupID(),
        twilioChatId: '',
      },
    }).then((d) => { });
    this.setState({ twilioChatId: '' });

    // var array = [...this.state.agentConversations]; // make a separate copy of the array
    // var index = array.findIndex((a) => a.conversationId === conversationId);
    // // console.log(index);
    // if (index !== -1) {
    //   array.splice(index, 1);
    //   this.setState({ agentConversations: array });
    // }
    // }
  };

  handleGenerateSummary = async () => {
    this.setState({ isSummaryLoad: true });
    var conId = this.state.selectedChat.conversationId;
    await AxiosAPI({
      method: 'get',
      url: `${gAPI_ConversationSummaryByAssistant}/${conId}?group_id=${getGroupID()}`,
    }).then(async (res) => {
      if (res.data === 'success') {
        var count = 0;
        if (this.state.selectedChat.conversationSummary === null) {
          var intervalid = setInterval(() => {
            count++;
            if (count === 10) {
              clearInterval(intervalid);
              this.props.getChat(conId);
            }
          }, 500);
        } else {
          this.props.getChat(conId);
        }
      }
    });
  };

  handleEmailRefresh = () => {
    var conId = this.state.selectedChat.conversationId;
    this.props.getChat(conId);
  };

  handleChangeLocale = async (locale, direction) => {
    this.setState({ translateLang: locale, isTranslate: true });
  };

  handleOldConversation = (conversationId) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Conversations_By_Id}/${conversationId}/conversation?gid=${getGroupID()}`,
    }).then(
      (res) => {
        this.setState({
          agentConversations: [
            res.data,
            ...(this.state.agentConversations || []),
          ],
          activeChat: res.data.conversationId,
          conversationSummary: this.isValidJSON(
            res.data.conversationSummary.assistantResponse
          )
            ? JSON.parse(res.data.conversationSummary.assistantResponse)
            : res.data.conversationSummary.assistantResponse,
          isSummaryLoad: false,
        });
        this.props.getChat(res.data.conversationId);
        this.audio.play();
      },
      (error) => {
        this.setState({ loading: false, error, isLoading: false });
      }
    );
  };

  openWhatsAppTab = (phoneNumber) => {
    this.setState({
      whatsAppConnection: !this.state.whatsAppConnection,
      detailsTab: 'sendwhatsapp',
      preFillPhoneNumber: phoneNumber,
    });
  };

  render() {
    const {
      usersListApp: { properties },
      user,
      rolePermission,
    } = this.props;

    const {
      selectedChat,
      startDate,
      endDate,
      modal,
      ticketType,
      ticketPriority,
      popupProperty,
      isVisibleTicketBtn,
      selectedTopic,
      webRTCIntegration,
      showDialPad,
      rtcNumber,
      detailsTab,
    } = this.state;

    return (
      <Fragment>
        <Row>
          <Colxx xxs="12" md="4" className="mb-2 col-sm-12 col-md-4 pr-0" style={{ paddingLeft: '6px', paddingTop: '10px' }}>
            <CardHeader className="pl-0 pr-0 ">
              <Nav
                tabs
                className="card-header-tabs ml-0 mr-0 d-flex"
                style={{
                  backgroundColor: 'white',
                  border: '1px solid lightgray',
                  // paddingTop: '6px'
                }}
              >
                <NavItem className="text-center nav-width">
                  <NavLink
                    style={{
                      background: `${this.props.activeTab === 'Active' ? 'white' : 'none'
                        }`,
                      cursor: 'pointer',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                    }}
                    className={classnames({
                      active: this.props.activeTab === 'Active',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.props.handleSelectedTab('Active');
                    }}
                    to="#"
                    title="Active Conversation"
                  >
                    <i className="svg-class">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLineJoin="round"
                          d="M8.625 9.75a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H8.25m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0H12m4.125 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Zm0 0h-.375m-13.5 3.01c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.184-4.183a1.14 1.14 0 0 1 .778-.332 48.294 48.294 0 0 0 5.83-.498c1.585-.233 2.708-1.626 2.708-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                        />
                      </svg>
                    </i>
                  </NavLink>
                </NavItem>
                <NavItem className="text-center nav-width">
                  <NavLink
                    style={{
                      background: `${this.props.activeTab === 'AllConversations'
                        ? 'white'
                        : 'none'
                        }`,
                      cursor: 'pointer',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                    }}
                    className={classnames({
                      active: this.props.activeTab === 'AllConversations',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.props.handleSelectedTab('AllConversations');
                    }}
                    to="#"
                  >
                    <i className="svg-class">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLineJoin="round"
                          d="M2.25 12.76c0 1.6 1.123 2.994 2.707 3.227 1.087.16 2.185.283 3.293.369V21l4.076-4.076a1.526 1.526 0 0 1 1.037-.443 48.282 48.282 0 0 0 5.68-.494c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                        />
                      </svg>
                    </i>

                    {this.props.activeTab === 'AllConversations' && (
                      <IntlMessages id="content.allconversation" />
                    )}
                  </NavLink>
                </NavItem>
                <NavItem className="text-center nav-width">
                  <NavLink
                    style={{
                      background: `${this.props.activeTab === 'Tickets' ? 'white' : 'none'
                        }`,
                      cursor: 'pointer',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                    }}
                    className={classnames({
                      active: this.props.activeTab === 'Tickets',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.props.handleSelectedTab('Tickets');
                    }}
                    to="#"
                    title="Tickets"
                  >
                    <i className="svg-class">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLineJoin="round"
                          d="M16.5 6v.75m0 3v.75m0 3v.75m0 3V18m-9-5.25h5.25M7.5 15h3M3.375 5.25c-.621 0-1.125.504-1.125 1.125v3.026a2.999 2.999 0 0 1 0 5.198v3.026c0 .621.504 1.125 1.125 1.125h17.25c.621 0 1.125-.504 1.125-1.125v-3.026a2.999 2.999 0 0 1 0-5.198V6.375c0-.621-.504-1.125-1.125-1.125H3.375Z"
                        />
                      </svg>
                    </i>
                  </NavLink>
                </NavItem>
                <NavItem
                  className="text-center float-right"
                  style={{ width: '27%', background: '' }}
                >
                  {this.state.isFiltering && (
                    <Card
                      style={{
                        position: 'absolute',
                        zIndex: '1',
                        top: '2rem',
                        right: '1rem',
                        boxShadow:
                          '0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)',
                      }}
                    >
                      <CardBody>
                        <Colxx md="12" className="mb-2">
                          <DatePicker
                            //  disabledKeyboardNavigation={false}
                            style={{ borderRadius: '10px' }}
                            selected={startDate ? new Date(startDate) : null} // ensure Date object
                            onChange={this.handleChangeDate}
                            placeholderText="Start Date"
                            dateFormat="dd/MM/yyyy" // correct format
                          />
                        </Colxx>
                        <Colxx xxs="12" md="12" className="mb-2">
                          <DatePicker
                            //   disabledKeyboardNavigation={false}
                            style={{ borderRadius: '10px' }}
                            selected={endDate ? new Date(endDate) : null} // always Date object
                            onChange={this.handleChangeEndDate}
                            placeholderText="End Date"
                            dateFormat="dd/MM/yyyy" //correct format
                          />
                        </Colxx>
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Select
                            isMulti={true}
                            // components={{ Input: CustomSelectInput }}
                            className="react-select"
                            classNamePrefix="react-select"
                            name="code"
                            placeholder="Countries"
                            onChange={this.handleChangeSelect}
                            options={
                              country
                                ? reactSelectOptionDiffrentPro(
                                  country,
                                  true,
                                  'code',
                                  'name',
                                  'All Countries'
                                )
                                : []
                            }
                            value={this.state.selectedCountry}
                          />
                        </Colxx>
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Input
                            type="select"
                            value={this.state.feedback}
                            name="feedback"
                            onChange={this.handleInputChange}
                          >
                            <option value="All">All Feedback</option>
                            <option value="Like">Positive FeedBack</option>
                            <option value="Dislike">Negative Feedback</option>
                            <option value="None">No Feedback</option>
                          </Input>
                        </Colxx>
                        {/* <Colxx xxs="12" md="12" className="mb-2">
                          <Select
                            isMulti={true}
                            // components={{ Input: CustomSelectInput }}
                            className="react-select"
                            classNamePrefix="react-select"
                            name="topicName"
                            options={
                              topic
                                ? reactSelectOptionDiffrentPro(
                                  topic,
                                  true,
                                  'topic',
                                  'topic',
                                  'All Topics'
                                )
                                : []
                            }
                            placeholder="Topics"
                            value={selectedTopic}
                            onChange={this.handleChangeSelect}
                          />
                        </Colxx> */}
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Input
                            type="text"
                            name="facebookSenderName"
                            onChange={this.handleChangeFB}
                            value={this.state.facebookSenderName}
                            placeholder="Facebook User Name"
                          />
                        </Colxx>
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Input
                            type="text"
                            name="googleSenderName"
                            onChange={this.handleChangeGoogle}
                            value={this.state.googleSenderName}
                            placeholder="Google User Name"
                          />
                        </Colxx>
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Input
                            type="text"
                            name="whatsAppSenderPhoneNumber"
                            onChange={this.handleChangeWhatsApp}
                            value={this.state.whatsAppSenderPhoneNumber}
                            placeholder="WhatsApp Phone Number"
                          />
                        </Colxx>
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Input
                            type="select"
                            value={this.state.channel}
                            name="channel"
                            onChange={this.handleInputChange}
                          >
                            <option value="All">All Channels</option>
                            <option value="WebsiteDirectLine">Website</option>
                            <option value="FacebookDirectLine">Facebook</option>
                            <option value="InstagramDirectLine">
                              Instagram
                            </option>
                            <option value="WhatsApp">WhatsApp</option>
                            <option value="WeChat">WeChat</option>
                            <option value="PhoneSuite">Voice</option>
                            <option value="EmailDirectLine"> Email </option>
                            <option value="TeamsApp"> Teams </option>
                          </Input>
                        </Colxx>
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Input
                            type="select"
                            value={this.state.filterstatus}
                            name="filterstatus"
                            onChange={this.handleInputChange}
                          >
                            <option value="All">All</option>
                            <option value="Opened">Open</option>
                            <option value="Closed">Closed</option>
                          </Input>
                        </Colxx>
                        <Colxx xxs="12" md="12" className="mb-2">
                          <Button
                            size="xs"
                            color="primary"
                            className="mb-2 mt-2"
                            onClick={() => this.handleSubmitClick()}
                          >
                            <IntlMessages id="forms.submit" />
                          </Button>
                          <Button
                            size="xs"
                            color="secondary"
                            className="mb-2 mt-2 ml-2"
                            onClick={() =>
                              this.setState({ isFiltering: false })
                            }
                          >
                            <IntlMessages id="pages.cancel" />
                          </Button>
                          <UncontrolledDropdown>
                            <DropdownToggle
                              caret
                              color="primary"
                              className="btn-xs"
                              outline
                            >
                              Download CSV
                              {/* {buttonText} */}
                            </DropdownToggle>
                            <DropdownMenu right>
                              <DropdownItem>
                                <CSVLink
                                  data={this.state.csvConversation}
                                  headers={[
                                    { key: 'r1', label: '' },
                                    { key: 'r2', label: '' },
                                    { key: 'r3', label: '' },
                                    { key: 'r4', label: '' },
                                    { key: 'r5', label: '' },
                                  ]}
                                  filename="conversation.csv"
                                >
                                  <span>
                                    Export Conversation List
                                  </span>
                                </CSVLink>
                              </DropdownItem>
                              <DropdownItem onClick={() =>
                                this.setState({ isExport: !this.state.isExport })
                              }>
                                Export Message Logs
                              </DropdownItem>

                            </DropdownMenu>
                          </UncontrolledDropdown>
                          {/* <Button
                            size="xs"
                            color="dark"
                            className="mb-2 mt-2 ml-2"
                          >
                            <CSVLink
                              data={this.state.csvConversation}
                              headers={[
                                { key: 'r1', label: '' },
                                { key: 'r2', label: '' },
                                { key: 'r3', label: '' },
                                { key: 'r4', label: '' },
                                { key: 'r5', label: '' },
                              ]}
                              filename="conversation.csv"
                            >
                              <span style={{ color: 'white' }}>
                                Download CSV
                              </span>
                            </CSVLink>
                          </Button> */}
                        </Colxx>
                      </CardBody>
                    </Card>
                  )}
                  <Button
                    size="xs"
                    outline
                    color="primary"
                    style={{ marginTop: '12px' }}
                    className="  btn-round"
                    onClick={() =>
                      this.setState({ isFiltering: !this.state.isFiltering })
                    }
                    title="Filter"
                  >
                    <FontAwesomeIcon icon={faFilter} className="fa mr-1" />
                  </Button>
                  {/* <Button
                    size="xs"
                    outline
                    color="primary"
                    style={{ marginTop: '12px' }}
                    className="btn-round ml-2"
                    onClick={() =>
                      this.setState({ isExport: !this.state.isExport })
                    }
                    title="Export Conversation">
                    <FontAwesomeIcon icon={faFileExcel} className='fa mr-1'></FontAwesomeIcon>
                  </Button> */}
                  {(this.state.isSocial === true ||
                    this.state.isEmail === true) &&
                    (this.state.showNewOptions !== undefined &&
                      this.state.showNewOptions === true ? (
                      <Button
                        size="xs"
                        outline
                        style={{ marginTop: '12px' }}
                        color="primary"
                        onClick={() => this.setState({ showNewOptions: false })}
                        className="mt-2 ml-2 btn-round"
                      >
                        <FontAwesomeIcon
                          icon={faArrowDown}
                          className="fa mr-1"
                        />
                      </Button>
                    ) : (
                      <Button
                        size="xs"
                        outline
                        color="primary"
                        style={{ marginTop: '12px' }}
                        onClick={() => this.setState({ showNewOptions: true })}
                        className=" ml-2 btn-round"
                        title="Email"
                      >
                        <FontAwesomeIcon icon={faPlus} className="fa mr-1" />
                      </Button>
                    ))}
                  {/* {webRTCIntegration !== undefined && (
                    <Button
                      size="xs"
                      outline
                      style={{ marginTop: '12px' }}
                      color="primary"
                      className=" ml-2 btn-round"
                      onClick={this.handleNewCall}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="16"
                        height="16"
                        className="fa mr-1"
                        viewBox="0 0 24 24"
                        style={{ fill: 'white' }}
                      >
                        <circle cx="12" cy="6" r="2"></circle>
                        <circle cx="6" cy="6" r="2"></circle>
                        <circle cx="18" cy="6" r="2"></circle>
                        <circle cx="12" cy="12" r="2"></circle>
                        <circle cx="6" cy="12" r="2"></circle>
                        <circle cx="18" cy="12" r="2"></circle>
                        <circle cx="12" cy="18" r="2"></circle>
                      </svg>
                    </Button>
                  )} */}

                  {this.state.showNewOptions !== undefined &&
                    this.state.showNewOptions === true && (
                      <Row>
                        <Fragment>
                          <div
                            style={{
                              position: 'absolute',
                              top: '50px',
                              zIndex: '999',
                              right: '80px',
                            }}
                          >
                            {/* <Colxx xxs="12" md="12" className="mt-1">
                              <Button
                                color="primary"
                                className="mb-2 btn-round btn-call mr-2"
                                outline
                                onClick={this.handleNewCall}
                              >
                                + Call
                              </Button>
                            </Colxx> */}
                            {this.state.isEmail === true && (
                              <Colxx xxs="12" md="12" className="mt-1">
                                <Button
                                  color="secondary"
                                  className="mb-2 btn-round btn-call mr-2"
                                  // outline
                                  onClick={() =>
                                    this.setState({
                                      openEmail: !this.state.openEmail,
                                    })
                                  }
                                >
                                  + Email
                                </Button>
                              </Colxx>
                            )}
                            {this.state.isSocial === true &&
                              this.state?.whatsAppIntegration && (
                                <Colxx xxs="12" md="12" className="mt-1">
                                  <Button
                                    color="secondary"
                                    className="mb-2 btn-round btn-call mr-2"
                                    onClick={() =>
                                      this.setState({
                                        whatsAppConnection:
                                          !this.state.whatsAppConnection,
                                        detailsTab: 'sendwhatsapp',
                                      })
                                    }
                                  >
                                    + WhatsApp
                                  </Button>
                                </Colxx>
                              )}
                            <Colxx xxs="12" md="12" className="mt-1">
                              <Button
                                color="secondary"
                                className="mb-2 btn-round btn-call mr-2"
                                onClick={() => {
                                  this.props.openCreateTicket();
                                }}
                              >
                                + Ticket
                              </Button>
                            </Colxx>
                          </div>
                        </Fragment>
                      </Row>
                    )}
                </NavItem>
              </Nav>
            </CardHeader>
            <TabContent activeTab={this.props.activeTab} className="pl-0 pr-0">
              <TabPane tabId="AllConversations" className="chat-app-tab-pane">
                {/* <Row>
                                    {this.state.isFiltering && (
                                        <Card style={{ position: "absolute", zIndex: "1", top: "7.7rem", marginLeft: "1rem", boxShadow: "0 1px 20px 20px rgb(0 0 0 / 4%), 0 1px 6px rgb(0 0 0 / 4%)" }}>
                                            <CardBody>
                                                <Colxx md="12" className="mb-2">
                                                    <DatePicker
                                                        selected={startDate}
                                                        onChange={this.handleChangeDate}
                                                        placeholderText="Start Date"
                                                        dateFormat="MMM DD, YYYY"
                                                    />
                                                </Colxx>
                                                <Colxx xxs="12" md="12" className="mb-2">
                                                    <DatePicker
                                                        selected={endDate}
                                                        onChange={this.handleChangeEndDate}
                                                        placeholderText="End Date"
                                                        dateFormat="MMM DD, YYYY"
                                                    />
                                                </Colxx>
                                            
                                                <Colxx xxs="12" md="12" className="mb-2">
                                                    <Select
                                                        isMulti={true}
                                                        // components={{ Input: CustomSelectInput }}
                                                        className="react-select"
                                                        classNamePrefix="react-select"
                                                        name="code"
                                                        placeholder="Countries"
                                                        onChange={this.handleChangeSelect}
                                                        options={
                                                            country
                                                                ? reactSelectOptionDiffrentPro(
                                                                    country,
                                                                    true,
                                                                    'code',
                                                                    'name',
                                                                    'All Countries'
                                                                )
                                                                : []
                                                        }
                                                        value={this.state.selectedCountry}
                                                    />
                                                </Colxx>
                                                <Colxx xxs="12" md="12" className="mb-2">
                                                    <Input
                                                        type="select"
                                                        value={this.state.feedback}
                                                        name="feedback"
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option value="All">All Feedback</option>
                                                        <option value="Like">Positive FeedBack</option>
                                                        <option value="Dislike">Negative Feedback</option>
                                                        <option value="None">No Feedback</option>
                                                    </Input>
                                                </Colxx>
                                                <Colxx xxs="12" md="12" className="mb-2">
                                                    <Select
                                                        isMulti={true}
                                                        // components={{ Input: CustomSelectInput }}
                                                        className="react-select"
                                                        classNamePrefix="react-select"
                                                        name="topicName"
                                                        options={
                                                            topic
                                                                ? reactSelectOptionDiffrentPro(
                                                                    topic,
                                                                    true,
                                                                    'topic',
                                                                    'topic',
                                                                    'All Topics'
                                                                )
                                                                : []
                                                        }
                                                        placeholder="Topics"
                                                        value={selectedTopic}
                                                        onChange={this.handleChangeSelect}
                                                    />
                                                </Colxx>
                                                <Colxx xxs="12" md="12" className="mb-2">
                                                    <Input
                                                        type="text"
                                                        name="facebookSenderName"
                                                        onChange={this.handleChangeFB}
                                                        value={this.state.facebookSenderName}
                                                        placeholder="Facebook User Name"
                                                    />
                                                </Colxx>
                                                <Colxx xxs="12" md="12" className="mb-2">
                                                    <Input
                                                        type="text"
                                                        name="googleSenderName"
                                                        onChange={this.handleChangeGoogle}
                                                        value={this.state.googleSenderName}
                                                        placeholder="Google User Name"
                                                    />
                                                </Colxx>
                                                <Colxx xxs="12" md="12" className="mb-2">
                                                    <Input
                                                        type="text"
                                                        name="whatsAppSenderPhoneNumber"
                                                        onChange={this.handleChangeWhatsApp}
                                                        value={this.state.whatsAppSenderPhoneNumber}
                                                        placeholder="WhatsApp Phone Number"
                                                    />
                                                </Colxx>
                                                <Colxx xxs="12" md="12" className="mb-2">
                                                    <Input
                                                        type="select"
                                                        value={this.state.channel}
                                                        name="channel"
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option value="All">All Channels</option>
                                                        <option value="WebsiteDirectLine">Web</option>
                                                        <option value="FacebookDirectLine">Facebook</option>
                                                        <option value="Phone">Voice</option>
                                                        <option value="GoogleBusinessMessage">
                                                            Google Business Message
                                                        </option>
                                                        <option value="WhatsApp">WhatsApp</option>
                                                    </Input>
                                                </Colxx>
                                                <Colxx xxs="12" md="12" className="mb-2">
                                                    <Input
                                                        type="select"
                                                        value={this.state.filterstatus}
                                                        name="filterstatus"
                                                        onChange={this.handleInputChange}
                                                    >
                                                        <option value="All">All</option>
                                                        <option value="Opened">Open</option>
                                                        <option value="Closed">Closed</option>
                                                    </Input>
                                                </Colxx>
                                                <Colxx xxs="12" md="12" className="mb-2">
                                                    <Button
                                                        size="xs"
                                                        color="primary"
                                                        className="mb-2 mt-2"
                                                        onClick={() => this.handleSubmitClick()}
                                                    >
                                                        <IntlMessages id="forms.submit" />
                                                    </Button>
                                                    <Button
                                                        size="xs"
                                                        color="secondary"
                                                        className="mb-2 mt-2 ml-2"
                                                        onClick={() => this.setState({ isFiltering: false })}
                                                    >
                                                        Cancel
                                                    </Button>
                                                </Colxx>
                                            </CardBody>
                                        </Card>
                                    )}
                                </Row> */}
                <Card className="card-box">
                  <CardBody className="mt-0">
                    <Archives
                      startDate={this.state.startDate}
                      endDate={this.state.endDate}
                      offset={this.state.offset}
                      items={this.state.items}
                      isLoading={this.state.isLoading}
                      data={
                        Array.isArray(this.state.data) ? this.state.data : []
                      }
                      activeIndex={this.state.activeIndex}
                      pid={this.props.propertyId}
                      handleContactClick={this.handleContactClick}
                      loadMoreConversations={this.loadMoreConversations}
                      handleMaskClick={this.handleMaskClick}
                      isMasked={this.state.isMasked}
                      properties={properties}
                      featuresUrl={this.props.featuresUrl}
                    />
                  </CardBody>
                </Card>
                {showDialPad && (
                  <DialPad
                    isvisible={showDialPad}
                    //isOnCall={isOnCall}
                    toggle={() => this.setState({ showDialPad: false })}
                    handlePhoneNumber={(val) => this.handleRTCNumber(val)}
                  ></DialPad>
                )}
              </TabPane>
            </TabContent>
          </Colxx>
          <Colxx
            xxs="12"
            md={
              selectedChat?.channel !== undefined &&
                selectedChat?.channel === 'EmailDirectLine'
                ? '5'
                : '4'
            }
            className={`mb-2 col-sm-12 ${selectedChat?.channel !== undefined &&
              selectedChat?.channel === 'EmailDirectLine'
              ? 'col-md-5'
              : 'col-md-4'
              } card-gap`}
            style={{ paddingTop: '10px' }}
          >
            {/* <CardTitle>Chat</CardTitle>{' '} */}
            <CardHeader className="pl-0 pr-0 ">
              <Nav
                tabs
                className="card-header-tabs ml-0 mr-0"
                style={{
                  backgroundColor: 'white',
                  border: '1px solid lightgray',
                  // paddingTop: '6px',
                }}
              >
                {/* Visitor Name Section */}
                <NavItem
                  className="text-center nav-width mb-2"
                  style={{ width: '30%', background: '' }}
                >
                  {this.state.isOncall === false && (
                    <div className="">
                      <div className="text-left ">
                        {this.getVisitorNameDetail()}
                      </div>
                      {/* Visitor Online Detail */}
                      <div >
                        {this.getVisitorOnlineDetail()}
                      </div>
                    </div>
                  )}
                </NavItem>

                {/* Action Buttons Section */}

                <NavItem
                  style={{ paddingTop: '3px', paddingBottom: '12px' }}
                  className="text-right float-right"
                // style={{ width: '50%', background: '' }}
                >
                  {this.state.isOncall === false && (
                    <div className="text-right ml-2 d-flex">
                      {/* SMS or Reply Button */}
                      {selectedChat !== null &&
                        selectedChat.channel === 'PhoneSuite' ? (
                        <Fragment>
                          {this.state.twilioChatId !== '' ? null : (
                            <Button
                              size="xs"
                              outline
                              color="primary"
                              className="ml-2 btn-round"
                              style={{ marginTop: '10px' }}
                              title="SMS"
                            >
                              <FontAwesomeIcon icon={faSms} />{' '}
                            </Button>
                          )}
                        </Fragment>
                      ) : (
                        <Fragment>
                          {selectedChat !== null &&
                            !this.state?.isLatestConversation &&
                            selectedChat?.channel === 'WhatsApp' ? (
                            <Button
                              size="xs"
                              outline
                              color={rolePermission === 'Agent' ? 'primary' : 'grey'}
                              disabled={rolePermission !== 'Agent'}
                              onClick={() =>
                                this.openWhatsAppTab(
                                  selectedChat?.visitor?.whatsAppSenderPhoneNumber
                                )
                              }
                              className="ml-2 btn-round"
                              style={{ marginTop: '10px' }}
                              title={
                                !this.state?.isLatestConversation
                                  ? 'You have a 24-hour window to reply to a customer message on WhatsApp Business from the time the customer last messaged you. If you send a reply within this 24-hour "customer care window," you can send any message type. After the 24-hour window closes, you can only send messages using pre-approved Message Templates, which restart the 24-hour window when the customer responds.'
                                  : rolePermission !== 'Agent'
                                    ? 'You need agent role to reply to conversations or to accept customer initiated Live Chat requests'
                                    : ''
                              }
                            >
                              <FontAwesomeIcon
                                icon={faReply}
                                className="fa"
                              />{' '}
                            </Button>
                          ) : (
                            <Button
                              size="xs"
                              outline
                              color={rolePermission === 'Agent' ? 'primary' : 'grey'}
                              disabled={rolePermission !== 'Agent'}
                              className="ml-2 btn-round"
                              style={{ marginTop: '10px' }}
                              onClick={() => {
                                this.twilioConnectionToUserChat(
                                  selectedChat.botConversationId,
                                  selectedChat.visitor.location,
                                  selectedChat.visitor.ipAddress,
                                  selectedChat.conversationId,
                                  selectedChat.channel
                                );
                              }}
                              title={
                                rolePermission !== 'Agent'
                                  ? 'You need agent role to reply to conversations or to accept customer initiated Live Chat requests'
                                  : ''
                              }
                            >
                              <FontAwesomeIcon
                                icon={faReply}
                                className="fa"
                              />{' '}
                            </Button>
                          )}
                        </Fragment>
                      )}

                      {/* Call Button */}
                      {webRTCIntegration !== undefined && (
                        <Button
                          size="xs"
                          outline
                          color="primary"
                          className="ml-2 btn-round"
                          style={{ marginTop: '10px' }}
                          onClick={() =>
                            this.setState({
                              isOncall: !this.state.isOncall,
                            })
                          }
                          title={
                            selectedChat !== null &&
                              selectedChat.channel === 'PhoneSuite'
                              ? 'Call Back'
                              : 'Call'
                          }
                        >
                          <FontAwesomeIcon icon={faPhone} className="fa" />
                        </Button>
                      )}
                    </div>
                  )}
                </NavItem>

                <NavItem
                  style={{ paddingTop: '2px' }}
                  className=" text-right float-right"
                // style={{ width: '20%', background: '' }}
                >
                  {this.state.isOncall === false && (
                    <div className="text-right  d-flex">
                      {/* Convert to Ticket */}
                      <Button
                        size="xs"
                        outline
                        color="primary"
                        onClick={this.toggle}
                        className="ml-2 btn-round"
                        style={{ marginTop: '10px' }}
                        title="Convert to Ticket"
                      >
                        <FontAwesomeIcon icon={faTicketAlt} />{' '}
                      </Button>
                      {/* Open/Close Conversation */}
                      {selectedChat && (
                        <Fragment>
                          {selectedChat.status === 'Opened' ? (
                            <Button
                              size="xs"
                              outline
                              color="primary"
                              onClick={() => this.handleStatusSubmit('Closed')}
                              className="mx-2 btn-round"
                              style={{ marginTop: '10px' }}
                              title="Close Conversation"
                            >
                              <FontAwesomeIcon icon={faArrowDown} />{' '}
                            </Button>
                          ) : (
                            <Button
                              size="xs"
                              outline
                              color="primary"
                              className="mx-1 btn-round"
                              style={{ marginTop: '10px' }}
                              onClick={() => this.handleStatusSubmit('Opened')}
                              title="Open Conversation"
                            >
                              <i className="iconsminds-right-1"></i>
                            </Button>
                          )}
                        </Fragment>
                      )}

                      {/* Language Dropdown */}
                      <UncontrolledDropdown
                        className="dropdown-menu-right mr-2"
                        style={{ marginTop: '10px' }}
                      >
                        <DropdownToggle
                          size="xs"
                          outline
                          color="primary"
                          className="btn-round align-items-center mr-1 ml-1"
                          title="Language"
                        >
                          {this.state.translateLang === '' ? (
                            <span>
                              <FontAwesomeIcon
                                icon={faLanguage}
                                className="fa"
                                style={{ fontSize: '15px' }}
                              />
                            </span>
                          ) : (
                            <span className="name">
                              {this.state.translateLang.toUpperCase()}
                            </span>
                          )}
                        </DropdownToggle>

                        <DropdownMenu right style={{ marginTop: '100px' }}>
                          {localeOptions.map((elem, index) => (
                            <DropdownItem
                              onClick={() =>
                                this.handleChangeLocale(elem.id, elem.direction)
                              }
                              key={index}
                            >
                              {elem.name}
                            </DropdownItem>
                          ))}
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </div>
                  )}
                  <Fragment>
                    {/* {selectedChat && webRTCIntegration !== undefined ? (
                      <WebRTC
                        isOncall={this.state.isOncall}
                        rtcNumber={rtcNumber}
                        number={this.getVisitorCallingNumber()}
                        handleBackToChat={() =>
                          this.setState({ isOncall: !this.state.isOncall })
                        }
                        webRTCIntegration={webRTCIntegration}
                      ></WebRTC>
                    ) : null} */}
                  </Fragment>
                </NavItem>
              </Nav>
            </CardHeader>

            {!this.state.twilioLoaded ? (
              <Fragment>
                <div className="loading"></div>
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '16px',
                    margin: '8px 0',
                  }}
                >
                  <IntlMessages id="dashboard.hang_in_there" />
                </div>
              </Fragment>
            ) : (
              <Chat
                chat={selectedChat}
                openWhatsAppTab={this.openWhatsAppTab}
                isLatestConversation={
                  this.state?.isLatestConversation
                    ? this.state?.isLatestConversation
                    : false
                }
                availabilityIntegration={this.props.integrations.filter(
                  (f) =>
                    (f.channel === 'Amadues' ||
                      f.channel === 'SHRCRS' ||
                      f.channel === 'RMSBookingEngine' ||
                      f.channel === 'MEWS' ||
                      f.channel === 'Sabre') &&
                    f.properties?.includes(this.props.propertyId) &&
                    f.disabled === false
                )}
                emailIntegration={this.state?.emailIntegration}
                userName={this.props.userName}
                locale={this.props.locale}
                quickReplyTemplates={this.state.quickReplyTemplates}
                email={this.props.email}
                accessToken={this.state.accessToken}
                twilioConversations={this.state.twilioConversations}
                twilioChatId={this.state.twilioChatId}
                forceRefresh={this.state.forceRefresh}
                handleEmailRefresh={this.handleEmailRefresh}
                closeTwilioConversation={this.closeTwilioConversation}
                ref={this.myChatRef}
                profileName={user && user.profile.name}
                stopBlink={this.stopBlink}
                propertyId={this.props.propertyId}
                chatReplyTemplates={this.state.chatReplyTemplates}
                setBlankTwilioId={this.setBlankTwilioId}
                translateLang={this.state.translateLang}
                isTranslate={this.state.isTranslate}
                twilioConnectionToUserChat={this.twilioConnectionToUserChat}
              />
            )}
            {/* {selectedChat.messages != null &&
                                                selectedChat.messages.length > 0 &&
                                                <Reply quickReplies={this.state.chatReplyTemplates} selectedChat={selectedChat} ></Reply>
                                            } */}
          </Colxx>

          <Colxx
            xxs="12"
            md={
              selectedChat?.channel !== undefined &&
                selectedChat?.channel === 'EmailDirectLine'
                ? '3'
                : '4'
            }
            className={`mb-2 col-sm-12 ${selectedChat?.channel !== undefined &&
              selectedChat?.channel === 'EmailDirectLine'
              ? 'col-md-3'
              : 'col-md-4'
              } pl-0`}
            style={{ paddingRight: '12px', paddingTop: '10px' }}
          >
            <CardHeader className="pl-0 pr-0 pt-0">
              <Nav
                tabs
                className="card-header-tabs ml-0 mr-0"
                style={{
                  backgroundColor: 'white',
                  border: '1px solid lightgray',
                  // paddingTop: '6px',
                }}
              >
                <NavItem className="text-center  nav-width">
                  <NavLink
                    style={{
                      background: `${detailsTab === 'CallInfo' ? 'white' : 'none'
                        }`,
                      cursor: 'pointer',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                    }}
                    className={classnames({
                      active: detailsTab === 'CallInfo',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.setState({ detailsTab: 'CallInfo' });
                    }}
                    to="#"
                  >
                    <i
                      className="iconsminds-profile"
                      style={{
                        fontSize: '17px',
                        color: 'var(--theme-color-1)',
                      }}
                    >
                      {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                      strokeWidth="1"
                      stroke="currentColor"
                      class="size-6"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M7.5 8.25h9m-9 3H12m-9.75 1.51c0 1.6 1.123 2.994 2.707 3.227 1.129.166 2.27.293 3.423.379.35.026.67.21.865.501L12 21l2.755-4.133a1.14 1.14 0 0 1 .865-.501 48.172 48.172 0 0 0 3.423-.379c1.584-.233 2.707-1.626 2.707-3.228V6.741c0-1.602-1.123-2.995-2.707-3.228A48.394 48.394 0 0 0 12 3c-2.392 0-4.744.175-7.043.513C3.373 3.746 2.25 5.14 2.25 6.741v6.018Z"
                      />
                    </svg> */}
                    </i>

                    {detailsTab === 'CallInfo' &&
                      (selectedChat !== null &&
                        selectedChat.channel === 'PhoneSuite' ? (
                        <IntlMessages id="content.callinfo" />
                      ) : (
                        <IntlMessages id="content.visitorinfo" />
                      ))}
                  </NavLink>
                </NavItem>
                <NavItem className="text-center  nav-width">
                  <NavLink
                    style={{
                      background: `${detailsTab === 'AiInsight' ? 'white' : 'none'
                        }`,
                      cursor: 'pointer',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                    }}
                    className={classnames({
                      active: detailsTab === 'AiInsight',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.setState({ detailsTab: 'AiInsight' });
                    }}
                    to="#"
                    title="AI Insights"
                  >
                    {' '}
                    <i className="svg-class">
                      <svg
                        version="1.0"
                        xmlns="http://www.w3.org/2000/svg"
                        stroke="currentColor"
                        viewBox="0 0 512.000000 512.000000"
                        preserveAspectRatio="xMidYMid meet"
                        className="size-6"
                      >
                        <g
                          transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                          stroke="none"
                        >
                          <path d="M2505 5096 c-33 -33 -37 -68 -33 -266 l3 -172 28 -24 c16 -13 41 -24 57 -24 16 0 41 11 57 24 l28 24 3 172 c2 95 1 188 -3 207 -9 47 -46 83 -85 83 -19 0 -40 -9 -55 -24z" />
                          <path d="M1539 4845 c-29 -16 -52 -66 -42 -93 16 -47 190 -336 210 -349 30 -20 87 -9 108 20 28 40 18 75 -67 226 -46 80 -94 158 -108 173 -31 34 -67 42 -101 23z" />
                          <path d="M3486 4828 c-46 -48 -196 -318 -196 -354 0 -16 7 -39 15 -51 21 -29 78 -40 108 -20 20 13 194 302 211 350 9 28 -20 86 -49 97 -41 16 -55 12 -89 -22z" />
                          <path d="M2450 4434 c-277 -36 -459 -102 -671 -244 -89 -60 -285 -259 -349 -354 -95 -142 -171 -326 -212 -511 -8 -39 -13 -129 -13 -255 1 -177 3 -205 27 -300 73 -289 176 -470 391 -684 71 -70 136 -145 145 -165 11 -26 18 -83 22 -201 5 -142 9 -171 28 -206 25 -49 72 -98 113 -120 26 -13 29 -20 29 -64 0 -71 18 -144 45 -185 l24 -35 -24 -35 c-29 -43 -48 -125 -39 -174 3 -20 19 -59 34 -86 27 -50 28 -51 9 -74 -11 -13 -26 -48 -35 -79 -39 -135 46 -278 186 -312 85 -20 140 9 140 75 0 41 -36 85 -70 85 -36 0 -77 28 -88 60 -13 35 -8 56 21 87 20 22 26 23 207 23 194 0 243 8 260 40 18 34 12 85 -13 108 -22 21 -32 22 -209 22 -112 0 -198 4 -218 11 -39 14 -65 65 -51 101 20 54 31 56 248 60 197 3 202 3 227 27 34 32 36 88 4 119 -22 19 -36 21 -223 24 -223 3 -238 7 -256 68 -6 19 -9 51 -7 70 l3 35 230 3 c219 2 230 3 252 24 33 31 31 87 -3 119 l-26 24 -288 3 -288 3 -23 25 c-23 24 -24 34 -29 192 -6 161 -7 169 -38 235 -26 56 -53 90 -160 195 -143 141 -201 217 -266 349 -94 190 -131 364 -123 583 8 224 60 394 179 588 66 108 232 278 342 352 141 94 316 163 479 190 93 15 303 12 396 -5 374 -71 691 -313 864 -660 131 -263 154 -597 61 -882 -64 -198 -152 -332 -331 -510 -111 -110 -139 -143 -165 -200 -31 -66 -32 -74 -38 -235 -5 -159 -6 -168 -29 -192 -24 -26 -27 -26 -168 -26 -163 0 -206 -11 -224 -57 -11 -31 -7 -58 15 -88 12 -17 29 -21 123 -25 l108 -5 3 -35 c5 -48 -13 -102 -39 -119 -12 -7 -58 -16 -102 -20 -83 -7 -101 -18 -113 -66 -16 -63 43 -105 144 -105 48 0 62 -4 79 -23 30 -33 34 -54 19 -91 -17 -40 -55 -56 -136 -56 -43 0 -61 -5 -78 -20 -29 -27 -37 -63 -20 -96 18 -40 52 -54 129 -54 55 0 69 -4 86 -22 29 -32 34 -53 21 -88 -19 -55 -42 -60 -301 -60 l-234 0 -27 -26 c-33 -34 -34 -74 -2 -111 l24 -28 181 -5 182 -5 -30 -47 c-87 -137 -265 -153 -399 -37 -62 54 -152 24 -152 -51 0 -72 144 -172 279 -193 209 -32 416 104 470 310 9 31 18 43 40 51 69 24 130 108 146 199 8 49 -14 134 -44 172 -19 25 -19 25 9 75 15 28 31 67 34 87 9 49 -10 131 -39 174 l-24 35 24 35 c27 41 45 114 45 185 0 44 3 51 29 64 41 22 88 71 113 120 19 35 23 64 28 206 4 119 10 175 22 202 9 20 73 93 145 165 240 238 352 449 409 768 17 97 19 303 4 405 -89 584 -548 1055 -1125 1155 -94 16 -275 26 -335 19z" />
                          <path d="M823 4130 c-47 -19 -59 -96 -20 -133 42 -42 323 -197 356 -197 69 0 105 82 59 134 -28 31 -311 196 -347 201 -14 3 -36 0 -48 -5z" />
                          <path d="M4230 4133 c-47 -19 -309 -178 -329 -200 -45 -51 -7 -133 61 -133 32 0 315 156 356 197 22 22 29 64 16 98 -12 30 -69 51 -104 38z" />
                          <path d="M2008 3386 c-70 -29 -113 -64 -154 -125 -43 -64 -58 -114 -58 -198 1 -130 77 -243 203 -301 48 -22 73 -27 178 -30 l122 -4 3 -483 3 -483 24 -26 c30 -32 78 -34 115 -5 l26 20 0 490 0 489 90 0 90 0 0 -489 0 -490 26 -20 c37 -29 85 -27 115 5 l24 26 3 483 3 483 122 4 c105 3 130 8 178 30 78 36 133 89 171 165 26 53 31 76 32 136 0 84 -15 134 -58 199 -113 169 -353 199 -505 62 -29 -26 -62 -69 -78 -102 -25 -51 -29 -70 -33 -187 l-5 -130 -85 0 -85 0 -5 130 c-4 117 -8 136 -33 187 -77 157 -268 230 -429 164z m219 -172 c60 -45 68 -66 71 -195 l4 -119 -99 0 c-74 0 -108 5 -139 19 -127 58 -133 225 -10 302 41 26 134 22 173 -7z m839 7 c123 -75 117 -244 -10 -302 -31 -14 -65 -19 -138 -19 l-98 0 0 104 c0 111 8 147 43 185 48 52 145 67 203 32z" />
                          <path d="M564 3146 c-40 -18 -59 -62 -44 -101 20 -52 29 -54 248 -55 202 0 203 0 227 25 44 43 29 112 -29 135 -41 15 -364 12 -402 -4z" />
                          <path d="M4151 3149 c-55 -22 -69 -92 -26 -134 24 -25 25 -25 227 -25 221 1 229 3 249 58 14 41 -9 86 -52 101 -39 14 -364 14 -398 0z" />
                          <path d="M1115 2334 c-97 -51 -280 -160 -305 -181 -60 -50 -27 -143 49 -143 36 0 332 164 364 202 24 28 21 72 -5 102 -30 33 -66 40 -103 20z" />
                          <path d="M3934 2340 c-50 -20 -70 -89 -36 -128 9 -12 88 -62 174 -112 172 -99 207 -109 246 -67 30 32 29 87 -1 115 -29 27 -311 190 -340 197 -12 2 -32 0 -43 -5z" />
                        </g>
                      </svg>
                    </i>
                    {detailsTab === 'AiInsight' && ' AI Insights'}
                  </NavLink>
                </NavItem>
                {this.state.isSocial === true &&
                  this.state?.whatsAppIntegration && (
                    <NavItem className="text-center nav-width">
                      <NavLink
                        style={{
                          background: `${detailsTab === 'sendwhatsapp' ? 'white' : 'none'
                            }`,
                          cursor: 'pointer',
                          paddingTop: '12px',
                          paddingBottom: '13px',
                        }}
                        className={classnames({
                          active: detailsTab === 'sendwhatsapp',
                          'nav-link': true,
                        })}
                        onClick={() => {
                          this.setState({ detailsTab: 'sendwhatsapp' });
                        }}
                        to="#"
                        title="New WhatsApp"
                      >
                        <div className="d-flex">
                          <FontAwesomeIcon
                            icon={faWhatsapp}
                            className="fa mt-1 mr-1"
                            style={{
                              fontSize: '18px',
                              color: 'var(--theme-color-1)',
                            }}
                          />

                          {detailsTab === 'sendwhatsapp' && (
                            <p className="mt-1">New Message</p>
                          )}
                        </div>
                      </NavLink>
                    </NavItem>
                  )}
                <NavItem className="text-center nav-width">
                  <NavLink
                    style={{
                      background: `${detailsTab === 'KnowledgeSearch' ? 'white' : 'none'
                        }`,
                      cursor: 'pointer',
                      paddingTop: '12px',
                      paddingBottom: '12px',
                    }}
                    className={classnames({
                      active: detailsTab === 'KnowledgeSearch',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.setState({ detailsTab: 'KnowledgeSearch' });
                    }}
                    to="#"
                    title="Knowledge Search"
                  >
                    <i className="svg-class">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z"
                        />
                      </svg>
                    </i>
                    {detailsTab === 'KnowledgeSearch' && (
                      <IntlMessages id="content.knowledgesearch" />
                    )}
                  </NavLink>
                </NavItem>
                <NavItem className="text-center nav-width">
                  <NavLink
                    style={{
                      background: `${detailsTab === 'Reservation' ? 'white' : 'none'
                        }`,
                      cursor: 'pointer',
                      paddingTop: '12px',
                      paddingBottom: '15px',
                    }}
                    className={classnames({
                      active: detailsTab === 'Reservation',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.setState({ detailsTab: 'Reservation' });
                    }}
                    to="#"
                    title="Reservations"
                  >
                    <i
                      className="iconsminds-calendar-4 mt-1 mr-1"
                      style={{
                        fontSize: '15px',
                        color: 'var(--theme-color-1)',
                      }}
                    />
                    {detailsTab === 'Reservation' && (
                      <span
                        style={{
                          visibility:
                            detailsTab === 'Reservation' ? 'visible' : 'hidden',
                          fontSize: '15px',
                        }}
                      >
                        Reservations
                      </span>
                    )}
                  </NavLink>
                </NavItem>
                {/* <NavItem className="text-center nav-width">
                  <NavLink
                    style={{
                      background: `${detailsTab === 'EmailAssist' ? 'white' : 'none'
                        }`,
                      cursor: 'pointer',
                    }}
                    className={classnames({
                      active: detailsTab === 'EmailAssist',
                      'nav-link': true,
                    })}
                    onClick={() => {
                      this.setState({ detailsTab: 'EmailAssist' });
                    }}
                    to="#"
                    title="Email Assist"
                  >
                    <i className="svg-class">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1"
                        stroke="currentColor"
                        class="size-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M9 3.75H6.912a2.25 2.25 0 0 0-2.15 1.588L2.35 13.177a2.25 2.25 0 0 0-.1.661V18a2.25 2.25 0 0 0 2.25 2.25h15A2.25 2.25 0 0 0 21.75 18v-4.162c0-.224-.034-.447-.1-.661L19.24 5.338a2.25 2.25 0 0 0-2.15-1.588H15M2.25 13.5h3.86a2.25 2.25 0 0 1 2.012 1.244l.256.512a2.25 2.25 0 0 0 2.013 1.244h3.218a2.25 2.25 0 0 0 2.013-1.244l.256-.512a2.25 2.25 0 0 1 2.013-1.244h3.859M12 3v8.25m0 0-3-3m3 3 3-3"
                        />
                      </svg>
                    </i>
                    {detailsTab === 'EmailAssist' && ' Email Assist'}
                  </NavLink>
                </NavItem> */}
                {this.props.integrations !== undefined &&
                  this.props.integrations.filter(
                    (f) =>
                      (f.channel === 'Amadues' || f.channel === 'SHRCRS') &&
                      f.properties?.includes(this.props.propertyId) &&
                      f.disabled === false
                  ).length > 0 && (
                    <NavItem className="text-center">
                      <NavLink
                        style={{
                          background: `${detailsTab === 'Availability & Rates'
                            ? 'white'
                            : 'none'
                            }`,
                          cursor: 'pointer',
                        }}
                        className={classnames({
                          active: detailsTab === 'Availability & Rates',
                          'nav-link': true,
                        })}
                        onClick={() => {
                          this.setState({ detailsTab: 'Availability & Rates' });
                        }}
                        to="#"
                        title="Availability & Rates"
                      >
                        <i className="svg-class">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            strokeWidth="1"
                            stroke="currentColor"
                            class="size-6"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M6.75 2.994v2.25m10.5-2.25v2.25m-14.252 13.5V7.491a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v11.251m-18 0a2.25 2.25 0 0 0 2.25 2.25h13.5a2.25 2.25 0 0 0 2.25-2.25m-18 0v-7.5a2.25 2.25 0 0 1 2.25-2.25h13.5a2.25 2.25 0 0 1 2.25 2.25v7.5m-6.75-6h2.25m-9 2.25h4.5m.002-2.25h.005v.006H12v-.006Zm-.001 4.5h.006v.006h-.006v-.005Zm-2.25.001h.005v.006H9.75v-.006Zm-2.25 0h.005v.005h-.006v-.005Zm6.75-2.247h.005v.005h-.005v-.005Zm0 2.247h.006v.006h-.006v-.006Zm2.25-2.248h.006V15H16.5v-.005Z"
                            />
                          </svg>
                        </i>

                        {detailsTab === 'Availability & Rates' && (
                          <IntlMessages id="content.availabilityrates" />
                        )}
                      </NavLink>
                    </NavItem>
                  )}
              </Nav>
            </CardHeader>
            <TabContent activeTab={this.state.detailsTab} className="pl-1 pr-1">
              <TabPane tabId="sendwhatsapp" className="chat-app-tab-pane">
                <NewWhatsAppConnection
                  preFillPhoneNumber={this.state?.preFillPhoneNumber || ''}
                  propertyId={this.props.propertyId}
                  handleOldConversation={this.handleOldConversation}
                  whatsAppIntegration={this.state?.whatsAppIntegration}
                  handleContactClick={this.handleContactClick}
                  visible={this.state.whatsAppConnection}
                  data={Array.isArray(this.state.data) ? this.state.data : []}
                  toggle={() =>
                    this.setState({
                      whatsAppConnection: !this.state.whatsAppConnection,
                    })
                  }
                ></NewWhatsAppConnection>
              </TabPane>

              <TabPane tabId="CallInfo" className="chat-app-tab-pane">
                {selectedChat && selectedChat.visitor != null && (
                  <Visitor
                    conversationSummary={
                      this.isValidJSON(
                        selectedChat.conversationSummary?.assistantResponse
                      )
                        ? JSON.parse(
                          selectedChat.conversationSummary?.assistantResponse
                        )
                        : selectedChat.conversationSummary?.assistantResponse
                    }
                    item={selectedChat}
                    hideButtons={true}
                    //twilioMakingConnection={this.twilioMakingConnection}
                    StopFacebookChat={this.StopFacebookChat}
                    ResumeFacebookChat={this.ResumeFacebookChat}
                    toggle={this.toggle}
                    recordingurl={this.state.recordingurl}
                    transcript={this.state.transcript}
                    quickReplyTemplates={this.state.quickReplyTemplates}
                    propertyId={this.props.propertyId}
                    loadQuickTemmplates={this.loadQuickTemmplates}
                    //statustoggle={this.statustoggle}
                    handleMaskClick={this.handleMaskClick}
                    isMasked={this.state.isMasked}
                    clickedLinks={
                      selectedChat.clickedLinks !== undefined
                        ? selectedChat.clickedLinks
                        : undefined
                    }
                    handleStatusSubmit={this.handleStatusSubmit}
                  />
                )}
              </TabPane>
              <TabPane tabId="AiInsight" className="chat-app-tab-pane ">
                <div className="scroll cardHeight visitor  conversation-height archive-card card-box">
                  {selectedChat && (
                    <Fragment>
                      <div className="icon-row-item mb-4">
                        <Button
                          size="xs"
                          outline
                          color="primary"
                          className="ml-1 btn-round mt-3 btn-insights"
                          onClick={() => this.handleGenerateSummary()}
                        >
                          {selectedChat &&
                            selectedChat.conversationSummary === null ? (
                            <Fragment>
                              <FontAwesomeIcon
                                className="plusicon"
                                icon={faPlus}
                              ></FontAwesomeIcon>{' '}
                              Generate Insights
                            </Fragment>
                          ) : (
                            <Fragment>
                              <svg
                                version="1.0"
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="24"
                                className="refresh"
                                viewBox="0 0 512.000000 512.000000"
                                preserveAspectRatio="xMidYMid meet"
                                fill="none"
                              >
                                <g
                                  transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
                                  stroke="none"
                                >
                                  <path d="M2390 5114 c-227 -19 -424 -53 -589 -103 -549 -165 -1035 -530 -1366 -1026 -145 -217 -277 -510 -350 -780 -31 -115 -28 -152 16 -189 l31 -26 368 0 c368 0 369 0 394 23 14 12 52 87 90 174 88 205 124 274 191 368 125 173 265 308 441 425 319 211 685 308 1060 280 255 -19 408 -59 619 -160 153 -74 271 -153 420 -282 5 -5 -93 -111 -242 -261 -260 -261 -273 -278 -273 -357 0 -78 53 -159 125 -191 38 -17 87 -19 835 -19 748 0 797 2 835 19 51 23 101 79 114 128 7 25 11 304 11 818 0 878 4 823 -77 896 -66 59 -157 69 -238 26 -16 -9 -129 -115 -250 -236 -121 -122 -223 -221 -228 -221 -4 0 -52 38 -107 84 -379 319 -815 515 -1310 591 -100 15 -425 27 -520 19z" />
                                  <path d="M125 2111 c-51 -23 -101 -79 -114 -128 -7 -25 -11 -304 -11 -816 0 -864 -4 -816 68 -890 64 -66 157 -80 242 -36 19 10 134 117 255 238 121 122 225 221 231 221 6 0 21 -12 35 -26 77 -83 345 -276 509 -366 222 -122 527 -228 790 -273 366 -62 797 -36 1165 71 541 158 1053 545 1375 1039 137 210 265 501 340 772 29 104 30 114 16 146 -28 68 -21 67 -418 67 -356 0 -357 0 -382 -22 -14 -13 -52 -88 -90 -175 -88 -205 -124 -274 -191 -368 -81 -113 -157 -196 -255 -283 -451 -398 -1074 -528 -1645 -345 -202 64 -409 179 -575 317 l-71 59 250 251 c258 260 271 277 271 356 0 78 -53 159 -125 191 -38 17 -87 19 -835 19 -748 0 -797 -2 -835 -19z" />
                                </g>
                              </svg>{' '}
                              <IntlMessages id="content.regenerateinsights" />
                            </Fragment>
                          )}
                        </Button>
                      </div>
                      {this.state.isSummaryLoad ? (
                        <div
                          className="loading"
                          style={{ position: 'absolute', top: '150px' }}
                        />
                      ) : (
                        selectedChat &&
                        selectedChat.conversationSummary !== null && (
                          <ConversationSummary
                            conversationSummary={
                              this.isValidJSON(
                                selectedChat.conversationSummary
                                  ?.assistantResponse
                              )
                                ? JSON.parse(
                                  selectedChat.conversationSummary
                                    ?.assistantResponse
                                )
                                : selectedChat.conversationSummary
                                  ?.assistantResponse
                            }
                            isLoading={this.state.isSummaryLoad}
                            tickettoggle={this.toggle}
                            handleStatusSubmit={this.handleStatusSubmit}
                            selectedChat={selectedChat}
                          ></ConversationSummary>
                        )
                      )}
                    </Fragment>
                  )}
                </div>
              </TabPane>
              <TabPane tabId="KnowledgeSearch" className="chat-app-tab-pane">
                <KnowledgeSearch></KnowledgeSearch>
              </TabPane>
              <TabPane tabId="Reservation" className="chat-app-tab-pane">
                <Reservations
                  reservationIds={
                    selectedChat?.reservationsIds ||
                    selectedChat?.reservationIds
                  }
                />
              </TabPane>
              <TabPane
                tabId="EmailAssist"
                className="chat-app-tab-pane"
              ></TabPane>
              {this.props.integrations !== undefined &&
                this.props.integrations.filter(
                  (f) =>
                    (f.channel === 'Amadues' || f.channel === 'SHRCRS') &&
                    f.properties?.includes(this.props.propertyId) &&
                    f.disabled === false
                ).length > 0 && (
                  <TabPane
                    tabId="Availability & Rates"
                    className="chat-app-tab-pane"
                  >
                    <AvailabilityAndRates
                      emailIntegration={this.state?.emailIntegration}
                      propertyId={this.props.propertyId}
                      amadues={
                        this.props.integrations.filter(
                          (f) =>
                            f.channel === 'Amadues' &&
                            f.properties?.includes(this.props.propertyId) &&
                            f.disabled === false
                        )[0]
                      }
                      shr={
                        this.props.integrations.filter(
                          (f) =>
                            f.channel === 'SHRCRS' &&
                            f.properties?.includes(this.props.propertyId) &&
                            f.disabled === false
                        )[0]
                      }
                    ></AvailabilityAndRates>
                  </TabPane>
                )}
            </TabContent>
          </Colxx>
        </Row>
        {this.TwiloConversation()}
        {this.TransferBotToMessanger()}
        {this.TransferToBot()}

        <Row>
          <Colxx xxs="12">
            <Modal isOpen={modal} toggle={this.toggle} size="lg">
              <ModalHeader toggle={this.toggle}>
                <IntlMessages id="Ticket Details" />
              </ModalHeader>
              <ModalBody>
                <Row>
                  <Colxx xxs="12">
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>Ticket Category</label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Select
                          className="react-select"
                          classNamePrefix="react-select"
                          name="category"
                          onChange={this.handleChangeMultiCategory}
                          options={this.state.categoryList}
                          value={this.state.ticketSelectedCategory}
                        />
                      </Colxx>
                    </Row>
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>Title</label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Input
                          name="ticketTitle"
                          value={this.state.ticketTitle}
                          onChange={this.handleInputChange}
                          type="text"
                          placeHolder="Title"
                        />
                      </Colxx>
                    </Row>
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>Notes</label>
                      </Colxx>
                      <Colxx xxs="9">
                        <ReactQuill
                          theme="snow"
                          onChange={(content, delta, source) =>
                            this.handleNotes(source, content)
                          }
                          modules={quillModules}
                          formats={quillFormats}
                          name="ticketNotes"
                        />
                      </Colxx>
                    </Row>
                    <Row className="mb-2">
                      <Colxx xxs="3">
                        <label>
                          <IntlMessages id="pages.status" />
                        </label>
                      </Colxx>
                      <Colxx xxs="9">
                        <Select
                          className="react-select"
                          classNamePrefix="react-select"
                          name="status"
                          value={this.state.ticketSelectedStatus}
                          onChange={this.handleStatus}
                          options={StatusOptions}
                        />
                      </Colxx>
                    </Row>
                    {this.state.ticketStatus === 'Pending' && (
                      <Row className="mb-2">
                        <Colxx xxs="3">
                          <label>Assign To</label>
                        </Colxx>
                        <Colxx xxs="9">
                          <Input
                            name="ticketAssignTo"
                            onChange={this.handleInputChange}
                            type="text"
                            value={this.state.ticketAssignTo}
                            placeholdertext="Enter Email"
                          />
                        </Colxx>
                      </Row>
                    )}
                    <Row>
                      <Colxx xxs="3">
                        <Button
                          color="primary"
                          className="mb-2"
                          onClick={this.handleTicketSubmit}
                        >
                          <IntlMessages id="forms.submit" />
                        </Button>
                      </Colxx>
                    </Row>
                  </Colxx>
                </Row>
              </ModalBody>
            </Modal>
            {this.state.openEmail && (
              <NewEmail
                propertyId={this.props.propertyId}
                emailIntegration={this.state?.emailIntegration}
                visible={this.state.openEmail}
                toggle={() =>
                  this.setState({ openEmail: !this.state.openEmail })
                }
              ></NewEmail>
            )}

            {this.state.isExport &&
              <Modal isOpen={this.state.isExport} toggle={() => this.setState({ isExport: !this.state.isExport })} size="lg">
                <ModalHeader toggle={() => this.setState({ isExport: !this.state.isExport })} >
                  <IntlMessages id="Generate Request For Excel Report" />
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Colxx xxs="12">
                      <Row className="mb-2">
                        <Colxx xxs="3" className="mb-2">
                          <label>Start Date</label>
                        </Colxx>
                        <Colxx md="9" className="mb-2">
                          <DatePicker
                            //  disabledKeyboardNavigation={false}
                            style={{ borderRadius: '10px' }}
                            selected={this.state.exportConData.fromDate ? new Date(this.state.exportConData.fromDate) : null} // ensure Date object
                            onChange={(date) => this.handleExportDateChange(date, "from")}
                            placeholderText="Start Date"
                            dateFormat="dd/MM/yyyy" // correct format
                          />
                        </Colxx>
                        <Colxx xxs="3" className="mb-2">
                          <label>End Date</label>
                        </Colxx>
                        <Colxx xxs="9" md="9" className="mb-2">
                          <DatePicker
                            //   disabledKeyboardNavigation={false}
                            style={{ borderRadius: '10px' }}
                            selected={this.state.exportConData.toDate ? new Date(this.state.exportConData.toDate) : null} // always Date object
                            onChange={(date) => this.handleExportDateChange(date, "to")}
                            placeholderText="End Date"
                            dateFormat="dd/MM/yyyy" //correct format
                          />
                        </Colxx>
                        {this.state.errorMessage && <Colxx xxs="12" className="mb-2">
                          <Alert color="danger">{this.state.errorMessage}</Alert>
                        </Colxx>
                        }
                        <Colxx xxs="3" className="mb-2">
                          <label>Channels</label>
                        </Colxx>
                        <Colxx xxs="9" className="mb-2">
                          <Select
                            components={{ Input: CustomSelectInput }}
                            className="react-select"
                            classNamePrefix="react-select"
                            isMulti={true}
                            name="form-field-name"
                            value={this.state.selectedChannel}
                            onChange={this.handleChangeMulti}
                            options={channels}
                          ></Select>
                        </Colxx>
                        <Colxx xxs="3" className="mb-2">
                          <label>Email</label>
                        </Colxx>
                        <Colxx xxs="9" className="mb-2">
                          <Input
                            name="email"
                            value={this.state.exportConData.email}
                            onChange={this.handleExportInputChange}
                            type="text"
                            placeHolder="Email"
                          />
                        </Colxx>
                      </Row>

                      <Row>
                        <Colxx xxs="3">
                          <Button
                            color="primary"
                            className="mb-2"
                            onClick={this.handleSubmitRequest}
                          >
                            <IntlMessages id="forms.submit" />
                          </Button>
                        </Colxx>
                      </Row>
                    </Colxx>
                  </Row>
                </ModalBody>
              </Modal>}
            {/* {this.state.whatsAppConnection && (
              <NewWhatsAppConnection
                propertyId={this.props.propertyId}
                whatsAppIntegration={this.state?.whatsAppIntegration}
                visible={this.state.whatsAppConnection}
                toggle={() =>
                  this.setState({
                    whatsAppConnection: !this.state.whatsAppConnection,
                  })
                }
              ></NewWhatsAppConnection>
            )} */}
            {/* <Modal isOpen={modal} toggle={this.toggle} size="lg">
                <ModalHeader toggle={this.toggle}>
                  <IntlMessages id="Ticket Details" />
                </ModalHeader>
                <ModalBody>
                  <Row>
                    <Colxx xxs="12">
                      <Row className="mb-2">
                        <Colxx xxs="3">
                          <label>
                            <IntlMessages id="Ticket Type" />
                          </label>
                        </Colxx>
                        <Colxx xxs="9">
                          <Input
                            type="select"
                            value={ticketType}
                            name="ticketType"
                            onChange={this.handleInputChange}
                          >
                            <option value="-1">Select Type</option>
                            {TicketTypeOptions.map((elem) => (
                              <option value={elem.value}>{elem.label}</option>
                            ))}
                          </Input>
                        </Colxx>
                      </Row>
                      <Row className="mb-2">
                        <Colxx xxs="3">
                          <label>
                            <IntlMessages id="Property" />
                          </label>
                        </Colxx>
                        <Colxx xxs="9">
                          <Select
                            isDisabled={true}
                            className="react-select"
                            classNamePrefix="react-select"
                            name="popupProperty"
                            value={properties && popupProperty}
                            onChange={this.handleChangeSelect}
                            options={
                              properties
                                ? reactSelectOption(properties, false)
                                : []
                            }
                          />
                        </Colxx>
                      </Row>
                      {ticketType === "MissingResponses" && (
                        <Fragment>
                          <Row className="mb-2">
                            <Colxx xxs="3">
                              <label>
                                <IntlMessages id="missed-response.missed-response-title" />
                              </label>
                            </Colxx>
                            <Colxx xxs="9">
                              <Input
                                name="missedResponseTitle"
                                onChange={this.handleInputChange}
                                placeholder="Missed Response Title"
                              />
                            </Colxx>
                          </Row>
                          <Row className="mb-2">
                            <Colxx xxs="3">
                              <label>
                                <IntlMessages id="Status" />
                              </label>
                            </Colxx>
                            <Colxx xxs="9">
                              <Input
                                type="select"
                                value={this.state.ticketStatus}
                                name="ticketStatus"
                                onChange={this.handleInputChange}
                              >
                                <option value="-1">Select Status</option>
                                {StatusOptionMissed.map((elem) => (
                                  <option value={elem.value}>{elem.label}</option>
                                ))}
                              </Input>
                            </Colxx>
                          </Row>
                        </Fragment>
                      )}
                      <Row className="mb-2">
                        <Colxx xxs="3">
                          <label>
                            <IntlMessages id="Comments" />
                          </label>
                        </Colxx>
                        <Colxx xxs="9">
                          <Input
                            name="ticketComments"
                            onChange={this.handleInputChange}
                            type="textarea"
                            placeholdertext="Comments"
                          />
                        </Colxx>
                      </Row>
                      <Row>
                        <Colxx xxs="3">
                          <Button
                            color="primary"
                            className="mb-2"
                            onClick={this.handleTicketSubmit}
                          >
                            <IntlMessages id="forms.submit" />
                          </Button>
                        </Colxx>
                      </Row>
                    </Colxx>
                  </Row>
                </ModalBody>
              </Modal> */}
          </Colxx>
        </Row>

        <Validation
          open={this.state.open}
          messages={this.state.msg}
          toggle={() => {
            this.setState({ open: false });
          }}
        ></Validation>
      </Fragment>
    );
  }
}
const mapStateToProps = ({
  chatListApp,
  usersListApp,
  settings,
  oidc,
  twilioConversationsReducer,
}) => {
  const { propertyId, timeZone, userName, locale, email } = settings;
  const { rolePermission } = usersListApp;
  return {
    chatListApp,
    usersListApp,
    propertyId,
    timeZone,
    locale,
    userName,
    email,
    user: oidc.user,
    rolePermission,
    twilioConversationsReducer,
  };
};

export default injectIntl(
  connect(mapStateToProps, {
    getChatList,
    getChatListSearch,
    getChat,
    getPropertyList,
    createTicket,
    BotBlink,
    AgentBlink,
    pushTwilioConversations,
  })(AllConversation)
);
